<template>
  <div class="DataTable">
    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="fullPage"
        color="#018389"
        loader="dots"
      ></loading>
    </div>

    <!-- <div class="decantingItemComponentForm"> -->
    <v-form ref="form" v-model="valid" lazy-validation>
      <div style="border-style: groove; border-width: 1px">
        <v-layout row wrap>
          <v-flex xs12 pa-2>
            <span v-if="this.kolicinaVina > 0"
              >Faza {{ this.faza_mark }} / Količina {{ this.kolicinaVina }}
              {{ this.jm_mark }}</span
            >
            <span v-else
              >Prazan tank / Kapacitet
              {{ this.preostalo_izabrani_tank_prazan }}
              {{ this.preostalo_izabrani_tank_prazan_jm }}</span
            >
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs5 pa-2>
            <v-autocomplete
              v-model="wine_to_select"
              :items="wine_to_items"
              item-value="id"
              item-text="wineLabel.name"
              label="Vino"
              persistent-hint
              return-object
              :disabled="disabled_vine"
              :rules="[(v) => !!v || 'Obavezan podatak']"
              required
            >
              <template slot="selection" slot-scope="data"
                >{{ data.item.year }} - {{ data.item.wineLabel.name }}</template
              >
              <template slot="item" slot-scope="data"
                >{{ data.item.year }} - {{ data.item.wineLabel.name }}</template
              >
            </v-autocomplete>
          </v-flex>
          <v-flex xs1 pa-3 v-if="disabled_vine === false">
            <v-tooltip top>
              <v-icon
                slot="activator"
                id="FloatingButton"
                @click="submit_parameter"
                >add</v-icon
              >
              <span>Unos novog vina</span>
            </v-tooltip>

            <!-- <button id="FloatingButton" @click="submit_parameter">
      <p>
        <v-icon>close</v-icon>
      </p>
          </button>-->
          </v-flex>
          <v-flex xs6 pa-2>
            <v-select
              ref="elementFaza"
              v-model="phase_to_select"
              :items="phase_to_items"
              item-text="name"
              item-value="id"
              label="Faza"
              persistent-hint
              return-object
              required
              :disabled="!edit"
            >
              <template slot="selection" slot-scope="data">
                <template v-if="data.item.id === undefined"
                  >Izaberite fazu</template
                >
                <template v-else>{{ data.item.name }}</template>
              </template>
              <template slot="item" slot-scope="data">
                <template v-if="data.item.id === undefined"
                  >Izaberite fazu</template
                >
                <template v-else>{{ data.item.name }}</template>
              </template>
            </v-select>
          </v-flex>
        </v-layout>
      </div>
    </v-form>
    <v-form ref="form_nevalidiraj" v-model="valid" lazy-validation>
      <!-- </v-form>
    <v-form ref="form" v-model="valid" lazy-validation> -->
      <!--<v-layout row wrap>-->
      <!--<v-flex xs6 pa-2>-->
      <!--<v-text-field-->
      <!--v-model="ID"-->
      <!--label="ID" readonly-->
      <!--&gt;</v-text-field>-->
      <!--</v-flex>-->
      <!--</v-layout> &lt;!&ndash; /.ID &ndash;&gt;-->

      <!-- :items="phase_to_items_pom" -->

      <v-layout row wrap>
        <v-flex xs5 pa-2>
          <v-autocomplete
            ref="element1"
            v-model="tank_to_select"
            :items="tank_to_items"
            item-value="tankPhaseWineId"
            item-text="name"
            :rules="[(v) => !!v || 'Obavezan podatak']"
            label="Tank iz kog se uzima vino"
            required
            persistent-hint
            return-object
            v-on:change="changeRoute"
            :disabled="disabled_tank"
          >
            <template slot="selection" slot-scope="data">
              <template v-if="data.item.phaseMark === null"
                >{{ data.item.name }} / (prazan tank) / Zapremina
                {{ data.item.capacity }}
                {{ data.item.unitOfMeasureMark }}</template
              >
              <template v-else-if="data.item.id === undefined"
                >Izaberite tank</template
              >
              <template v-else
                >{{ data.item.name }} / {{ data.item.phaseMark }} / Preostalo
                {{ data.item.currentQuantity }}
                {{ data.item.unitOfMeasureMark }}</template
              >
            </template>
            <template slot="item" slot-scope="data">
              <template v-if="data.item.phaseMark === null"
                >{{ data.item.name }} / (prazan tank) / Zapremina
                {{ data.item.capacity }}
                {{ data.item.unitOfMeasureMark }}</template
              >
              <template v-else-if="data.item.id === undefined"
                >Izaberite tank</template
              >
              <template v-else
                >{{ data.item.name }} / {{ data.item.phaseMark }} / Preostalo
                {{ data.item.currentQuantity }}
                {{ data.item.unitOfMeasureMark }}</template
              >
            </template>
          </v-autocomplete>
        </v-flex>
        <v-flex xs1 pa-2>
          <v-checkbox
            ref="element3"
            title="Prikazati tankove sa svim tipovima vina"
            v-model="cvalueTankovi"
            @change="onCheckboxChangeTankovi"
            :disabled="!edit || disabled_tank"
          ></v-checkbox>
        </v-flex>
        <v-flex xs2 pa-2>
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            max-width="290px"
            min-width="290px"
            :disabled="!edit"
          >
            <v-text-field
              slot="activator"
              v-model="dateFormatted"
              label="Datum"
              readonly
              :rules="[(v) => !!v || 'Obavezan podatak']"
              required
              @blur="date = parseDate(dateFormatted)"
              :disabled="!edit"
            ></v-text-field>
            <v-date-picker
              v-model="date"
              no-title
              @input="menu = false"
              :max="maxDate"
            ></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex
          xs1
          pa-2
          style="padding-left: 4px !important; padding-right: 4px !important"
        >
          <v-menu
            ref="menu1"
            :close-on-content-click="false"
            v-model="menu1"
            :nudge-right="0"
            :return-value.sync="time"
            transition="scale-transition"
            lazy
            offset-y
            full-width
            min-width="290px"
            @input="
              (value) =>
                value && $refs.picker && ($refs.picker.selectingHour = true)
            "
            :disabled="!edit"
          >
            <v-text-field
              slot="activator"
              v-model="time"
              label=""
              readonly
              :rules="[(v) => !!v || 'Obavezan podatak']"
              required
              :disabled="!edit"
            ></v-text-field>
            <v-time-picker
              v-model="time"
              ref="picker"
              full-width
              landscape
              class="mt-3"
              format="24hr"
              :allowed-minutes="allowedStep"
              v-on:change="$refs.menu1.save(time)"
            >
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="menu1 = false">Cancel</v-btn>
              <!-- <v-btn flat color="primary" @click="$refs.menu1.save(time)">OK</v-btn> -->
            </v-time-picker>
          </v-menu>
        </v-flex>
        <v-flex xs3 pa-2>
          <v-checkbox
            label="Pretoči sve"
            ref="element2"
            v-model="cvalue"
            @change="onCheckboxChange"
            :disabled="!edit"
          ></v-checkbox>
        </v-flex>
      </v-layout>
      <!-- /.Name -->
    </v-form>
    <v-form ref="form1" v-model="valid" lazy-validation>
      <v-layout row wrap>
        <v-flex xs2 pa-2>
          <v-text-field
            v-model="wine_quantity"
            label="Količina"
            type="number"
            :rules="[(v) => !!v || 'Obavezan podatak']"
            required
            :disabled="!edit"
          ></v-text-field>
        </v-flex>

        <v-flex xs2 pa-2>
          <v-select
            v-model="jm_dolivanja_select"
            :items="jm_items"
            item-text="mark"
            item-value="id"
            :rules="[(v) => !!v || 'Obavezan podatak']"
            label="JM"
            required
            persistent-hint
            return-object
            :disabled="!edit"
          ></v-select>
        </v-flex>
        <v-flex xs2 pa-2>
          <v-text-field
            v-model="sediment_quantity"
            :label="tekst_labele_1"
            type="number"
            :disabled="!edit"
          ></v-text-field>
        </v-flex>

        <v-flex xs2 pa-2>
          <v-select
            v-model="jm_sediment_select"
            :items="jm_sediment_items"
            item-text="mark"
            item-value="id"
            label="JM"
            persistent-hint
            return-object
            :disabled="!edit"
          ></v-select>
        </v-flex>
        <v-flex xs2 pa-2>
          <v-text-field
            v-model="outage_quantity"
            label="Rastur"
            type="number"
            :disabled="!edit"
          ></v-text-field>
        </v-flex>

        <v-flex xs2 pa-2>
          <v-select
            v-model="jm_outage_select"
            :items="jm_outage_items"
            item-text="mark"
            item-value="id"
            label="JM"
            persistent-hint
            return-object
            :disabled="!edit"
          ></v-select>
        </v-flex>
      </v-layout>
      <!-- /.Name -->

      <v-layout row wrap>
        <v-flex xs12 pa-2>
          <v-textarea
            v-model="opis"
            name="input-5-1"
            class="Description"
            label="Opis"
          ></v-textarea>
          <!-- <v-text-field v-model="opis" label="Opis"></v-text-field> -->
        </v-flex>
      </v-layout>
      <!-- /.Tank -->

      <v-layout row wrap>
        <v-flex xs12>
          <v-btn
            :disabled="!valid"
            @click="submit"
            class="AppButtonFilled"
            >Sačuvaj</v-btn
          >
          <v-btn
            @click="clear"
            class="AppButtonOutlined"
            >odustani</v-btn
          >
        </v-flex>
      </v-layout>
      <!-- /.Action buttons -->
    </v-form>

    <v-dialog v-model="dialogNote" scrollable content-class="ModalInModal">
      <v-container style="padding: 0px">
        <div class="DataTable">
          <div data-v-fae5bece class="v-card">
            <div
              data-v-fae5bece
              class="v-card__title headline lighten-2 v-card__title--primary"
              style="padding-left: 30px; padding-bottom: 0px"
            >
              <!-- Modal Titles  -->

              <div>Dodavanje novog vina</div>

              <button
                id="closeModalBtn"
                @click.prevent="closeModal"
                class="v-btn v-btn--flat white"
              >
                <v-icon>close</v-icon>
              </button>
            </div>

            <div data-v-fae5bece class="spacer"></div>

            <div v-if="this.dialogNote === true">
              <WineLabel2 @mounted="customMounted" style="padding-top: 0px" />
            </div>
          </div>
        </div>
        <!-- /.addingToTank -->
      </v-container>
    </v-dialog>
    <TokenComponent ref="frmtoken" />
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

import { serverBus } from "../main";
import { readJSON } from "../helpers/Functions";
import WineLabel2 from "../views/WineModal";
import TokenComponent from "../components/Token";

const MountedMixin = {
  mounted() {
    // alert(1);
    this.$emit("mounted");
  },
};

export default {
  name: "CoupageItem",
  components: {
    TokenComponent,
    WineLabel2: (resolve) => {
      setTimeout(() => {
        const component = WineLabel2;
        component.mixins = [];
        component.mixins.push(MountedMixin);
        resolve(component);
        // This could be the result of System.import of an async require
      }, 300);
    },
    Loading,
  },
  data: () => ({
    isLoading: false,
    loading: true,
    fullPage: true,

    valid: true,
    ID: "0",
    opis: "",
    tank_to_items: [],
    tank_to_items_init: [],
    tank_to_select: "",
    phase_to_items: [],
    wine_to_items: [],
    phase_to_select: undefined,
    // phase_to_select_pom: "",
    wine_to_select: undefined,
    vineyard_grape_variety_items: [],
    jm_dolivanja_select: "",
    jm_outage_select: "",
    jm_sediment_select: "",
    vineyard_grape_variety_select: "",
    date: null, //For datepicker
    menu: "",
    entry_date: null, //For datepicker
    entry_menu: "",
    wine_quantity: undefined,
    jm_items: [],
    outage_quantity: undefined,
    jm_outage_items: [],
    sediment_quantity: undefined,
    jm_sediment_items: [],
    id_tank_phase_wine: 0,
    id_tank: 0,
    id_tank_phase_wine_blend: 0,
    kolicinaVina: 0,
    kolicinaVinaPom: 0,
    preostalo_izabrani_tank: 0,
    preostalo_izabrani_tank_jm: "",
    preostalo_izabrani_tank_prazan: 0,
    preostalo_izabrani_tank_prazan_jm: "",
    faza_izabrani_tank: 0,
    faza: -1,
    tekst_labele_1: "",
    tip_vina_izabrani_tank: 0,
    tip_vina_izabrani_tank_naziv: "",
    phase_to_items_pom: [],
    tipVina: 0,
    tip_vina_izabrani_tank_pom: null,
    tip_vina_tank: 0,
    faza_vina: 0,
    cvalue: false,
    cvalueTankovi: false,
    disabled_vine: false,
    isEmptyTank: false,
    time: undefined,
    menu1: "",
    dialogNote: false,
    id_jedinica_mere: 0,
    faza_mark: "",
    jm_mark: "",
    disabled_tank: false,
    datetime_action: "",
    prethodna_faza: 0,
    prethodna_faza_stavke: 0,

    date: null,
    dateFormatted: null,
    edit: true,
  }),
  watch: {
    date(val) {
      this.dateFormatted = this.formatDate1(this.date);
    },
  },
  computed: {
    maxDate() {
      const today = new Date();
      // const dd = today.getUTCDate();
      return this.formatDate(today);
    },
  },
  methods: {
    formatDate1(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}.${month}.${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split(".");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    allowedStep: (m) => m % 5 === 0,
    customMounted() {
      // alert(this.tankId);

      if (this.dialogNote) {
      }
    },
    submit_parameter(e) {
      e.preventDefault();
      this.dialogNote = true;
    },
    closeModal() {
      this.dialogNote = false;
      this.getAllVina();
    },
    formatDate(date) {
      let month = `${date.getMonth() + 1}`;
      let day = `${date.getDate()}`;
      const year = date.getFullYear();

      if (month.length < 2) month = `0${month}`;
      if (day.length < 2) day = `0${day}`;

      return [year, month, day].join("-");
    },
    setTime() {
      const today = new Date();
      let Minutes = `${today.getMinutes()}`;
      let Hours = `${today.getHours()}`;

      if (Hours.length < 2) Hours = `0${Hours}`;
      if (Minutes.length < 2) Minutes = `0${Minutes}`;

      this.time = [Hours, Minutes].join(":");
    },
    setDate() {
      const today = new Date();
      let Year = `${today.getFullYear()}`;
      let Month = `${today.getMonth() + 1}`;
      let Day = `${today.getDate()}`;

      if (Month.length < 2) Month = `0${Month}`;
      if (Day.length < 2) Day = `0${Day}`;

      this.date = [Year, Month, Day].join("-");
    },
    formatTime(time) {
      let HH = time.split(":")[0];
      let mm = time.split(":")[1];

      return HH + ":" + mm;
    },
    newSifarnik() {
      if (this.tank_to_select !== undefined) {
        let kolicinaVina = Number(this.kolicinaVina);
        let wine_quantity = Number(this.wine_quantity);

        var pom_jm_dolivanja_select;
        if (this.jm_dolivanja_select === null) pom_jm_dolivanja_select = "0";
        if (typeof this.jm_dolivanja_select === "undefined")
          pom_jm_dolivanja_select = "0";
        else if (this.jm_dolivanja_select.id == null)
          pom_jm_dolivanja_select = this.jm_dolivanja_select;
        else pom_jm_dolivanja_select = this.jm_dolivanja_select.id;

        var pom_wine_to_select = "";

        if (typeof this.wine_to_select !== "undefined")
          if (typeof this.wine_to_select.id !== "undefined")
            if (this.wine_to_select.id == null)
              pom_wine_to_select = this.wine_to_select;
            else pom_wine_to_select = this.wine_to_select.id;
          else pom_wine_to_select = this.wine_to_select;

        var pom_phase_to_select = "";

        if (typeof this.phase_to_select !== "undefined")
          if (typeof this.phase_to_select.id !== "undefined")
            if (!isNaN(this.phase_to_select.id))
              pom_phase_to_select = this.phase_to_select.id;
            else pom_phase_to_select = "";
          else pom_phase_to_select = this.phase_to_select;

        if (Number(wine_quantity) === 0) {
          this.isLoading = false;

          alert("Uneta količina ne sme imati vrednost nula.");
        } else if (
          pom_wine_to_select === undefined ||
          pom_wine_to_select === ""
        ) {
          this.isLoading = false;
          alert("Morate izabrati vino.");
        } else if (
          Number(pom_phase_to_select) !== Number(this.faza) &&
          Number(this.faza) !== 0
        )
          if (this.isEmptyTank) {
            this.isLoading = false;
            alert("Izabrani tank je prazan");
          } else if (
            typeof this.wine_to_select === "undefined" &&
            this.tip_vina_izabrani_tank_pom !== this.tip_vina_tank &&
            this.tip_vina_izabrani_tank_pom !== null &&
            typeof this.tip_vina_izabrani_tank_pom !== "undefined"
          ) {
            this.isLoading = false;
            alert(
              "U tankovima se ne nalazi isto vino, morate navesti novo vino"
            );
          } else if (
            Number(this.faza) !== 0 &&
            Number(this.faza_izabrani_tank) !== Number(this.faza) &&
            typeof pom_phase_to_select === "undefined" &&
            this.faza_izabrani_tank !== null
          ) {
            this.isLoading = false;
            alert(
              "Kupažiranje nije moguće, izabrani tankovi se ne nalaze u istoj fazi"
            );
          } else if (
            Number(this.sediment_quantity) === 0 ||
            typeof this.sediment_quantity === "undefined" ||
            this.sediment_quantity === ""
          ) {
            var complexObject;

            if (
              Number(this.outage_quantity) === 0 ||
              typeof this.outage_quantity === "undefined" ||
              this.outage_quantity === ""
            ) {
              if (
                typeof this.wine_to_select !== "undefined" &&
                this.tip_vina_izabrani_tank_pom !== null &&
                typeof this.tip_vina_izabrani_tank_pom !== "undefined" &&
                this.tip_vina_izabrani_tank_pom !== this.tip_vina_tank
              )
                if (
                  this.faza_izabrani_tank !== null &&
                  typeof this.faza_izabrani_tank !== "undefined" &&
                  typeof pom_phase_to_select !== "undefined" &&
                  Number(pom_phase_to_select) !== 0
                )
                  complexObject = {
                    tankPhaseWineId: this.tank_to_select.tankPhaseWineId,
                    toTankId: this.id_tank,
                    toPhaseId: pom_phase_to_select,
                    toWineId: pom_wine_to_select,
                    decantingDate: this.date + "T" + this.time,
                    quantity: Number(this.wine_quantity),
                    // sediment: 0,
                    // outage: 0,
                    quantityUnitOfMeasureId: pom_jm_dolivanja_select,
                    // sedimentUnitOfMeasureId: null,
                    // outageUnitOfMeasureId: null,
                    description: this.opis,
                  };
                else
                  complexObject = {
                    tankPhaseWineId: this.tank_to_select.tankPhaseWineId,
                    toTankId: this.id_tank,
                    //toPhaseId: this.phase_to_select.id,
                    toWineId: pom_wine_to_select,
                    decantingDate: this.date + "T" + this.time,
                    quantity: Number(this.wine_quantity),
                    // sediment: 0,
                    // outage: 0,
                    quantityUnitOfMeasureId: pom_jm_dolivanja_select,
                    // sedimentUnitOfMeasureId: null,
                    // outageUnitOfMeasureId: null,
                    description: this.opis,
                  };
              else if (
                this.faza_izabrani_tank !== null &&
                typeof this.faza_izabrani_tank !== "undefined" &&
                typeof pom_phase_to_select !== "undefined" &&
                Number(pom_phase_to_select) !== 0
              )
                complexObject = {
                  tankPhaseWineId: this.tank_to_select.tankPhaseWineId,
                  toTankId: this.id_tank,
                  toPhaseId: pom_phase_to_select,
                  toWineId: pom_wine_to_select,
                  decantingDate: this.date + "T" + this.time,
                  quantity: Number(this.wine_quantity),
                  // sediment: 0,
                  // outage: 0,
                  quantityUnitOfMeasureId: pom_jm_dolivanja_select,
                  // sedimentUnitOfMeasureId: null,
                  // outageUnitOfMeasureId: null,
                  description: this.opis,
                };
              else
                complexObject = {
                  tankPhaseWineId: this.tank_to_select.tankPhaseWineId,
                  toTankId: this.id_tank,
                  //toPhaseId: this.phase_to_select.id,
                  toWineId: pom_wine_to_select,
                  decantingDate: this.date + "T" + this.time,
                  quantity: Number(this.wine_quantity),
                  // sediment: 0,
                  // outage: 0,
                  quantityUnitOfMeasureId: pom_jm_dolivanja_select,
                  // sedimentUnitOfMeasureId: null,
                  // outageUnitOfMeasureId: null,
                  description: this.opis,
                };
            } else if (
              typeof this.wine_to_select !== "undefined" &&
              this.tip_vina_izabrani_tank_pom !== null &&
              typeof this.tip_vina_izabrani_tank_pom !== "undefined" &&
              this.tip_vina_izabrani_tank_pom !== this.tip_vina_tank
            )
              if (
                this.faza_izabrani_tank !== null &&
                typeof this.faza_izabrani_tank !== "undefined" &&
                typeof pom_phase_to_select !== "undefined" &&
                Number(pom_phase_to_select) !== 0
              )
                complexObject = {
                  tankPhaseWineId: this.tank_to_select.tankPhaseWineId,
                  toTankId: this.id_tank,
                  toPhaseId: pom_phase_to_select,
                  toWineId: pom_wine_to_select,
                  decantingDate: this.date + "T" + this.time,
                  quantity: Number(this.wine_quantity),
                  // sediment: 0,
                  outage: this.outage_quantity,
                  quantityUnitOfMeasureId: pom_jm_dolivanja_select,
                  // sedimentUnitOfMeasureId: null,
                  outageUnitOfMeasureId: this.jm_outage_select.id,
                  description: this.opis,
                };
              else
                complexObject = {
                  tankPhaseWineId: this.tank_to_select.tankPhaseWineId,
                  toTankId: this.id_tank,
                  //toPhaseId: this.phase_to_select.id,
                  toWineId: pom_wine_to_select,
                  decantingDate: this.date + "T" + this.time,
                  quantity: Number(this.wine_quantity),
                  // sediment: 0,
                  outage: this.outage_quantity,
                  quantityUnitOfMeasureId: pom_jm_dolivanja_select,
                  // sedimentUnitOfMeasureId: null,
                  outageUnitOfMeasureId: this.jm_outage_select.id,
                  description: this.opis,
                };
            else if (
              this.faza_izabrani_tank !== null &&
              typeof this.faza_izabrani_tank !== "undefined" &&
              typeof pom_phase_to_select !== "undefined" &&
              Number(pom_phase_to_select) !== 0
            )
              complexObject = {
                tankPhaseWineId: this.tank_to_select.tankPhaseWineId,
                toTankId: this.id_tank,
                toPhaseId: pom_phase_to_select,
                toWineId: pom_wine_to_select,
                decantingDate: this.date + "T" + this.time,
                quantity: Number(this.wine_quantity),
                // sediment: 0,
                outage: this.outage_quantity,
                quantityUnitOfMeasureId: pom_jm_dolivanja_select,
                // sedimentUnitOfMeasureId: null,
                outageUnitOfMeasureId: this.jm_outage_select.id,
                description: this.opis,
              };
            else
              complexObject = {
                tankPhaseWineId: this.tank_to_select.tankPhaseWineId,
                toTankId: this.id_tank,
                //toPhaseId: this.phase_to_select.id,
                toWineId: pom_wine_to_select,
                decantingDate: this.date + "T" + this.time,
                quantity: Number(this.wine_quantity),
                // sediment: 0,
                outage: this.outage_quantity,
                quantityUnitOfMeasureId: pom_jm_dolivanja_select,
                // sedimentUnitOfMeasureId: null,
                outageUnitOfMeasureId: this.jm_outage_select.id,
                description: this.opis,
              };

            this.$http
              .post(
                this.globalServiceLocation +
                  this.globalPort +
                  "/tank_phase_wine/decanting",
                complexObject,
                {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization:
                      "Bearer  " + localStorage.getItem("user-token"),
                  },
                }
              )
              .then((response) => {
                this.isLoading = false;

                if (response.data.isEmptyTank) {
                  this.kolicinaVina = 0;
                  this.isEmptyTank = true;
                } else {
                  this.kolicinaVina =
                    Number(this.kolicinaVinaPom) + Number(this.wine_quantity);
                }

                this.id_tank_phase_wine = response.data.toTankPhaseWineId;

                serverBus.$emit("refresh_coupage", this.id_tank_phase_wine);

                this.disabled_vine = true;

                if (Number(this.tip_vina_tank) !== 0)
                  this.wine_to_select = Number(this.tip_vina_tank);
                else {
                  this.tip_vina_tank = Number(pom_wine_to_select);
                }

                if (Number(pom_phase_to_select) !== 0)
                  this.faza = Number(pom_phase_to_select);
                else this.faza = Number(this.faza_izabrani_tank);

                if (typeof this.phase_to_select.phaseMark !== "undefined")
                  this.faza_mark = this.phase_to_select.phaseMark;

                if (typeof this.jm_dolivanja_select.mark !== "undefined")
                  this.jm_mark = this.jm_dolivanja_select.mark;

                this.clear();
              })
              .catch((e) => {
                if (!e.response) {
                  this.isLoading = false;

                  alert(
                    this.$t("error.message")
                  );
                } else {
                  if (e.response.status === 401) {
                    this.$refs.frmtoken
                      .osvezavanjeTokena(
                        localStorage.getItem("user-refresh-token")
                      )
                      .then((result) => {
                        this.$http
                          .post(
                            this.globalServiceLocation +
                              this.globalPort +
                              "/tank_phase_wine/decanting",
                            complexObject,
                            {
                              headers: {
                                "Content-Type": "application/json",
                                Authorization:
                                  "Bearer  " +
                                  localStorage.getItem("user-token"),
                              },
                            }
                          )
                          .then((response) => {
                            this.isLoading = false;

                            if (response.data.isEmptyTank) {
                              this.kolicinaVina = 0;
                              this.isEmptyTank = true;
                            } else {
                              this.kolicinaVina =
                                Number(this.kolicinaVinaPom) +
                                Number(this.wine_quantity);
                            }

                            this.id_tank_phase_wine =
                              response.data.toTankPhaseWineId;

                            serverBus.$emit(
                              "refresh_coupage",
                              this.id_tank_phase_wine
                            );

                            this.disabled_vine = true;

                            if (Number(this.tip_vina_tank) !== 0)
                              this.wine_to_select = Number(this.tip_vina_tank);
                            else {
                              this.tip_vina_tank = Number(pom_wine_to_select);
                            }

                            if (Number(pom_phase_to_select) !== 0)
                              this.faza = Number(pom_phase_to_select);
                            else this.faza = Number(this.faza_izabrani_tank);

                            if (
                              typeof this.phase_to_select.phaseMark !==
                              "undefined"
                            )
                              this.faza_mark = this.phase_to_select.phaseMark;

                            if (
                              typeof this.jm_dolivanja_select.mark !==
                              "undefined"
                            )
                              this.jm_mark = this.jm_dolivanja_select.mark;

                            this.clear();
                          })
                          .catch((e) => {
                            this.isLoading = false;

                            let pomError = readJSON(e.response.data.message);
                            alert(pomError);
                          });
                      });
                  } else {
                    this.isLoading = false;

                    let pomError = readJSON(e.response.data.message);
                    alert(pomError);
                  }
                }
              });
          } else {
            this.Pretakanje(0);
          }
        // } else {
        //   this.outage_quantity = undefined;
        // }
        else if (this.isEmptyTank) {
          this.isLoading = false;
          alert("Izabrani tank je prazan");
        } else if (
          typeof this.wine_to_select === "undefined" &&
          this.tip_vina_izabrani_tank_pom !== this.tip_vina_tank &&
          this.tip_vina_izabrani_tank_pom !== null &&
          typeof this.tip_vina_izabrani_tank_pom !== "undefined"
        ) {
          this.isLoading = false;
          alert("U tankovima se ne nalazi isto vino, morate navesti novo vino");
        } else if (
          Number(this.faza) !== 0 &&
          Number(this.faza_izabrani_tank) !== Number(this.faza) &&
          typeof pom_phase_to_select === "undefined" &&
          this.faza_izabrani_tank !== null
        ) {
          this.isLoading = false;

          alert(
            "Kupažiranje nije moguće, izabrani tankovi se ne nalaze u istoj fazi"
          );
        }
        // else if (
        //   Number(this.tipVina) !== 0 &&
        //   Number(this.tipVina) !== Number(this.tip_vina_izabrani_tank) &&
        //   this.tip_vina_izabrani_tank !== 0
        // )
        //   alert(
        //     "Kupažiranje nije moguće, u izabranom tanku se nalazi " +
        //       this.tip_vina_izabrani_tank_naziv +
        //       " vino."
        //   );
        // else if (wine_quantity + outage_quantity > preostalo_izabrani_tank) {
        //   alert(
        //     "Količina vina u tanku је " +
        //       preostalo_izabrani_tank +
        //       " " +
        //       this.preostalo_izabrani_tank_jm +
        //       ", što je manje od unete količine!"
        //   );
        // }
        else if (
          Number(this.sediment_quantity) === 0 ||
          typeof this.sediment_quantity === "undefined" ||
          this.sediment_quantity === ""
        ) {
          var complexObject;

          if (
            Number(this.outage_quantity) === 0 ||
            typeof this.outage_quantity === "undefined" ||
            this.outage_quantity === ""
          ) {
            if (
              typeof this.wine_to_select !== "undefined" &&
              this.tip_vina_izabrani_tank_pom !== null &&
              typeof this.tip_vina_izabrani_tank_pom !== "undefined" &&
              this.tip_vina_izabrani_tank_pom !== this.tip_vina_tank
            )
              if (
                this.faza_izabrani_tank !== null &&
                typeof this.faza_izabrani_tank !== "undefined" &&
                typeof pom_phase_to_select !== "undefined" &&
                Number(pom_phase_to_select) !== 0
              )
                complexObject = {
                  tankPhaseWineId: this.tank_to_select.tankPhaseWineId,
                  toTankId: this.id_tank,
                  toPhaseId: pom_phase_to_select,
                  toWineId: pom_wine_to_select,
                  decantingDate: this.date + "T" + this.time,
                  quantity: Number(this.wine_quantity),
                  // sediment: 0,
                  // outage: 0,
                  quantityUnitOfMeasureId: pom_jm_dolivanja_select,
                  // sedimentUnitOfMeasureId: null,
                  // outageUnitOfMeasureId: null,
                  description: this.opis,
                };
              else
                complexObject = {
                  tankPhaseWineId: this.tank_to_select.tankPhaseWineId,
                  toTankId: this.id_tank,
                  //toPhaseId: this.phase_to_select.id,
                  toWineId: pom_wine_to_select,
                  decantingDate: this.date + "T" + this.time,
                  quantity: Number(this.wine_quantity),
                  // sediment: 0,
                  // outage: 0,
                  quantityUnitOfMeasureId: pom_jm_dolivanja_select,
                  // sedimentUnitOfMeasureId: null,
                  // outageUnitOfMeasureId: null,
                  description: this.opis,
                };
            else if (
              this.faza_izabrani_tank !== null &&
              typeof this.faza_izabrani_tank !== "undefined" &&
              typeof pom_phase_to_select !== "undefined" &&
              Number(pom_phase_to_select) !== 0
            )
              complexObject = {
                tankPhaseWineId: this.tank_to_select.tankPhaseWineId,
                toTankId: this.id_tank,
                toPhaseId: pom_phase_to_select,
                toWineId: pom_wine_to_select,
                decantingDate: this.date + "T" + this.time,
                quantity: Number(this.wine_quantity),
                // sediment: 0,
                // outage: 0,
                quantityUnitOfMeasureId: pom_jm_dolivanja_select,
                // sedimentUnitOfMeasureId: null,
                // outageUnitOfMeasureId: null,
                description: this.opis,
              };
            else
              complexObject = {
                tankPhaseWineId: this.tank_to_select.tankPhaseWineId,
                toTankId: this.id_tank,
                //toPhaseId: this.phase_to_select.id,
                toWineId: pom_wine_to_select,
                decantingDate: this.date + "T" + this.time,
                quantity: Number(this.wine_quantity),
                // sediment: 0,
                // outage: 0,
                quantityUnitOfMeasureId: pom_jm_dolivanja_select,
                // sedimentUnitOfMeasureId: null,
                // outageUnitOfMeasureId: null,
                description: this.opis,
              };
          } else if (
            typeof this.wine_to_select !== "undefined" &&
            this.tip_vina_izabrani_tank_pom !== null &&
            typeof this.tip_vina_izabrani_tank_pom !== "undefined" &&
            this.tip_vina_izabrani_tank_pom !== this.tip_vina_tank
          )
            if (
              this.faza_izabrani_tank !== null &&
              typeof this.faza_izabrani_tank !== "undefined" &&
              typeof pom_phase_to_select !== "undefined" &&
              Number(pom_phase_to_select) !== 0
            )
              complexObject = {
                tankPhaseWineId: this.tank_to_select.tankPhaseWineId,
                toTankId: this.id_tank,
                toPhaseId: pom_phase_to_select,
                toWineId: pom_wine_to_select,
                decantingDate: this.date + "T" + this.time,
                quantity: Number(this.wine_quantity),
                // sediment: 0,
                outage: this.outage_quantity,
                quantityUnitOfMeasureId: pom_jm_dolivanja_select,
                // sedimentUnitOfMeasureId: null,
                outageUnitOfMeasureId: this.jm_outage_select.id,
                description: this.opis,
              };
            else
              complexObject = {
                tankPhaseWineId: this.tank_to_select.tankPhaseWineId,
                toTankId: this.id_tank,
                //toPhaseId: this.phase_to_select.id,
                toWineId: pom_wine_to_select,
                decantingDate: this.date + "T" + this.time,
                quantity: Number(this.wine_quantity),
                // sediment: 0,
                outage: this.outage_quantity,
                quantityUnitOfMeasureId: pom_jm_dolivanja_select,
                // sedimentUnitOfMeasureId: null,
                outageUnitOfMeasureId: this.jm_outage_select.id,
                description: this.opis,
              };
          else if (
            this.faza_izabrani_tank !== null &&
            typeof this.faza_izabrani_tank !== "undefined" &&
            typeof pom_phase_to_select !== "undefined" &&
            Number(pom_phase_to_select) !== 0
          )
            complexObject = {
              tankPhaseWineId: this.tank_to_select.tankPhaseWineId,
              toTankId: this.id_tank,
              toPhaseId: pom_phase_to_select,
              toWineId: pom_wine_to_select,
              decantingDate: this.date + "T" + this.time,
              quantity: Number(this.wine_quantity),
              // sediment: 0,
              outage: this.outage_quantity,
              quantityUnitOfMeasureId: pom_jm_dolivanja_select,
              // sedimentUnitOfMeasureId: null,
              outageUnitOfMeasureId: this.jm_outage_select.id,
              description: this.opis,
            };
          else
            complexObject = {
              tankPhaseWineId: this.tank_to_select.tankPhaseWineId,
              toTankId: this.id_tank,
              //toPhaseId: this.phase_to_select.id,
              toWineId: pom_wine_to_select,
              decantingDate: this.date + "T" + this.time,
              quantity: Number(this.wine_quantity),
              // sediment: 0,
              outage: this.outage_quantity,
              quantityUnitOfMeasureId: pom_jm_dolivanja_select,
              // sedimentUnitOfMeasureId: null,
              outageUnitOfMeasureId: this.jm_outage_select.id,
              description: this.opis,
            };

          this.$http
            .post(
              this.globalServiceLocation +
                this.globalPort +
                "/tank_phase_wine/decanting",
              complexObject,
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization:
                    "Bearer  " + localStorage.getItem("user-token"),
                },
              }
            )
            .then((response) => {
              this.isLoading = false;

              if (response.data.isEmptyTank) {
                this.kolicinaVina = 0;
                this.isEmptyTank = true;
              } else {
                this.kolicinaVina =
                  Number(this.kolicinaVinaPom) + Number(this.wine_quantity);
              }
              this.id_tank_phase_wine = response.data.toTankPhaseWineId;

              serverBus.$emit("refresh_coupage", this.id_tank_phase_wine);

              this.disabled_vine = true;

              if (Number(this.tip_vina_tank) !== 0)
                this.wine_to_select = Number(this.tip_vina_tank);
              else {
                this.tip_vina_tank = Number(pom_wine_to_select);
              }

              if (Number(pom_phase_to_select) !== 0)
                this.faza = Number(pom_phase_to_select);
              else this.faza = Number(this.faza_izabrani_tank);

              if (typeof this.phase_to_select.phaseMark !== "undefined")
                this.faza_mark = this.phase_to_select.phaseMark;

              if (typeof this.jm_dolivanja_select.mark !== "undefined")
                this.jm_mark = this.jm_dolivanja_select.mark;

              this.clear();
            })
            .catch((e) => {
              if (!e.response) {
                this.isLoading = false;

                alert(
                  this.$t("error.message")
                );
              } else {
                if (e.response.status === 401) {
                  this.$refs.frmtoken
                    .osvezavanjeTokena(
                      localStorage.getItem("user-refresh-token")
                    )
                    .then((result) => {
                      this.$http
                        .post(
                          this.globalServiceLocation +
                            this.globalPort +
                            "/tank_phase_wine/decanting",
                          complexObject,
                          {
                            headers: {
                              "Content-Type": "application/json",
                              Authorization:
                                "Bearer  " + localStorage.getItem("user-token"),
                            },
                          }
                        )
                        .then((response) => {
                          this.isLoading = false;

                          if (response.data.isEmptyTank) {
                            this.kolicinaVina = 0;
                            this.isEmptyTank = true;
                          } else {
                            this.kolicinaVina =
                              Number(this.kolicinaVinaPom) +
                              Number(this.wine_quantity);
                          }
                          this.id_tank_phase_wine =
                            response.data.toTankPhaseWineId;

                          serverBus.$emit(
                            "refresh_coupage",
                            this.id_tank_phase_wine
                          );

                          this.disabled_vine = true;

                          if (Number(this.tip_vina_tank) !== 0)
                            this.wine_to_select = Number(this.tip_vina_tank);
                          else {
                            this.tip_vina_tank = Number(pom_wine_to_select);
                          }

                          if (Number(pom_phase_to_select) !== 0)
                            this.faza = Number(pom_phase_to_select);
                          else this.faza = Number(this.faza_izabrani_tank);

                          if (
                            typeof this.phase_to_select.phaseMark !==
                            "undefined"
                          )
                            this.faza_mark = this.phase_to_select.phaseMark;

                          if (
                            typeof this.jm_dolivanja_select.mark !== "undefined"
                          )
                            this.jm_mark = this.jm_dolivanja_select.mark;

                          this.clear();
                        })
                        .catch((e) => {
                          this.isLoading = false;

                          let pomError = readJSON(e.response.data.message);
                          alert(pomError);
                        });
                    });
                } else {
                  this.isLoading = false;

                  let pomError = readJSON(e.response.data.message);
                  alert(pomError);
                }
              }
            });
        } else {
          this.Pretakanje(0);
        }
      }
    },
    Pretakanje(idPom) {
      var complexObject;

      var pom_jm_dolivanja_select;
      if (this.jm_dolivanja_select === null) pom_jm_dolivanja_select = "0";
      if (typeof this.jm_dolivanja_select === "undefined")
        pom_jm_dolivanja_select = "0";
      else if (this.jm_dolivanja_select.id == null)
        pom_jm_dolivanja_select = this.jm_dolivanja_select;
      else pom_jm_dolivanja_select = this.jm_dolivanja_select.id;

      var pom_jm_sediment_select;
      if (this.jm_sediment_select === null) pom_jm_sediment_select = "0";
      else if (typeof this.jm_sediment_select === "undefined")
        pom_jm_sediment_select = "0";
      else if (this.jm_sediment_select.id == null)
        pom_jm_sediment_select = this.jm_sediment_select;
      else pom_jm_sediment_select = this.jm_sediment_select.id;

      var pom_jm_outage_select;

      if (this.jm_outage_select === null) pom_jm_outage_select = "0";
      else if (typeof this.jm_outage_select === "undefined")
        pom_jm_outage_select = "0";
      else if (this.jm_outage_select.id == null)
        pom_jm_outage_select = this.jm_outage_select;
      else pom_jm_outage_select = this.jm_outage_select.id;

      var pom_tank_to_select;

      if (this.tank_to_select.tankPhaseWineId == null)
        pom_tank_to_select = this.tank_to_select;
      else pom_tank_to_select = this.tank_to_select.tankPhaseWineId;

      var pom_phase_to_select;
      if (typeof this.phase_to_select !== "undefined")
        if (typeof this.phase_to_select.id !== "undefined")
          if (this.phase_to_select.id == null)
            pom_phase_to_select = this.phase_to_select;
          else pom_phase_to_select = this.phase_to_select.id;
        else pom_phase_to_select = this.phase_to_select;

      var pom_wine_to_select;

      if (typeof this.wine_to_select !== "undefined")
        if (typeof this.wine_to_select.id !== "undefined")
          if (this.wine_to_select.id == null)
            pom_wine_to_select = this.wine_to_select;
          else pom_wine_to_select = this.wine_to_select.id;
        else pom_wine_to_select = this.wine_to_select;

      if (
        Number(this.outage_quantity) === 0 ||
        typeof this.outage_quantity === "undefined" ||
        this.outage_quantity === ""
      )
        if (
          typeof this.wine_to_select !== "undefined" &&
          this.tip_vina_izabrani_tank_pom !== null &&
          typeof this.tip_vina_izabrani_tank_pom !== "undefined" &&
          this.tip_vina_izabrani_tank_pom !== this.tip_vina_tank
        )
          if (
            this.faza_izabrani_tank !== null &&
            typeof this.faza_izabrani_tank !== "undefined" &&
            typeof pom_phase_to_select !== "undefined" &&
            Number(pom_phase_to_select) !== 0
          )
            complexObject = {
              tankPhaseWineId: pom_tank_to_select,
              toTankId: this.id_tank,
              toPhaseId: pom_phase_to_select,
              toWineId: pom_wine_to_select,
              decantingDate: this.date + "T" + this.time,
              quantity: Number(this.wine_quantity),
              sediment: this.sediment_quantity,
              // outage: 0,
              quantityUnitOfMeasureId: pom_jm_dolivanja_select,
              sedimentUnitOfMeasureId: pom_jm_sediment_select,
              // outageUnitOfMeasureId: null,
              description: this.opis,
            };
          else
            complexObject = {
              tankPhaseWineId: pom_tank_to_select,
              toTankId: this.id_tank,
              //toPhaseId: pom_phase_to_select,
              toWineId: pom_wine_to_select,
              decantingDate: this.date + "T" + this.time,
              quantity: Number(this.wine_quantity),
              sediment: this.sediment_quantity,
              // outage: 0,
              quantityUnitOfMeasureId: pom_jm_dolivanja_select,
              sedimentUnitOfMeasureId: pom_jm_sediment_select,
              // outageUnitOfMeasureId: null,
              description: this.opis,
            };
        else if (
          this.faza_izabrani_tank !== null &&
          typeof this.faza_izabrani_tank !== "undefined" &&
          typeof pom_phase_to_select !== "undefined" &&
          Number(pom_phase_to_select) !== 0
        )
          complexObject = {
            tankPhaseWineId: pom_tank_to_select,
            toTankId: this.id_tank,
            toPhaseId: pom_phase_to_select,
            toWineId: pom_wine_to_select,
            decantingDate: this.date + "T" + this.time,
            quantity: Number(this.wine_quantity),
            sediment: this.sediment_quantity,
            // outage: 0,
            quantityUnitOfMeasureId: pom_jm_dolivanja_select,
            sedimentUnitOfMeasureId: pom_jm_sediment_select,
            // outageUnitOfMeasureId: null,
            description: this.opis,
          };
        else
          complexObject = {
            tankPhaseWineId: pom_tank_to_select,
            toTankId: this.id_tank,
            //toPhaseId: pom_phase_to_select,
            toWineId: pom_wine_to_select,
            decantingDate: this.date + "T" + this.time,
            quantity: Number(this.wine_quantity),
            sediment: this.sediment_quantity,
            // outage: 0,
            quantityUnitOfMeasureId: pom_jm_dolivanja_select,
            sedimentUnitOfMeasureId: pom_jm_sediment_select,
            // outageUnitOfMeasureId: null,
            description: this.opis,
          };
      else if (
        typeof this.wine_to_select !== "undefined" &&
        this.tip_vina_izabrani_tank_pom !== null &&
        typeof this.tip_vina_izabrani_tank_pom !== "undefined" &&
        this.tip_vina_izabrani_tank_pom !== this.tip_vina_tank
      )
        if (
          this.faza_izabrani_tank !== null &&
          typeof this.faza_izabrani_tank !== "undefined" &&
          typeof pom_phase_to_select !== "undefined" &&
          Number(pom_phase_to_select) !== 0
        )
          complexObject = {
            tankPhaseWineId: pom_tank_to_select,
            toTankId: this.id_tank,
            toPhaseId: pom_phase_to_select,
            toWineId: pom_wine_to_select,
            decantingDate: this.date + "T" + this.time,
            quantity: Number(this.wine_quantity),
            sediment: this.sediment_quantity,
            outage: this.outage_quantity,
            quantityUnitOfMeasureId: pom_jm_dolivanja_select,
            sedimentUnitOfMeasureId: pom_jm_sediment_select,
            outageUnitOfMeasureId: pom_jm_outage_select,
            description: this.opis,
          };
        else
          complexObject = {
            tankPhaseWineId: pom_tank_to_select,
            toTankId: this.id_tank,
            //toPhaseId: pom_phase_to_select,
            toWineId: pom_wine_to_select,
            decantingDate: this.date + "T" + this.time,
            quantity: Number(this.wine_quantity),
            sediment: this.sediment_quantity,
            outage: this.outage_quantity,
            quantityUnitOfMeasureId: pom_jm_dolivanja_select,
            sedimentUnitOfMeasureId: pom_jm_sediment_select,
            outageUnitOfMeasureId: pom_jm_outage_select,
            description: this.opis,
          };
      else if (
        this.faza_izabrani_tank !== null &&
        typeof this.faza_izabrani_tank !== "undefined" &&
        typeof pom_phase_to_select !== "undefined" &&
        Number(pom_phase_to_select) !== 0
      )
        complexObject = {
          tankPhaseWineId: pom_tank_to_select,
          toTankId: this.id_tank,
          toPhaseId: pom_phase_to_select,
          toWineId: pom_wine_to_select,
          decantingDate: this.date + "T" + this.time,
          quantity: Number(this.wine_quantity),
          sediment: this.sediment_quantity,
          outage: this.outage_quantity,
          quantityUnitOfMeasureId: pom_jm_dolivanja_select,
          sedimentUnitOfMeasureId: pom_jm_sediment_select,
          outageUnitOfMeasureId: pom_jm_outage_select,
          description: this.opis,
        };
      else
        complexObject = {
          tankPhaseWineId: pom_tank_to_select,
          toTankId: this.id_tank,
          // toPhaseId: pom_phase_to_select,
          toWineId: pom_wine_to_select,
          decantingDate: this.date + "T" + this.time,
          quantity: Number(this.wine_quantity),
          sediment: this.sediment_quantity,
          outage: this.outage_quantity,
          quantityUnitOfMeasureId: pom_jm_dolivanja_select,
          sedimentUnitOfMeasureId: pom_jm_sediment_select,
          outageUnitOfMeasureId: pom_jm_outage_select,
          description: this.opis,
        };

      let url;

      if (
        typeof pom_phase_to_select !== "undefined" &&
        this.prethodna_faza_stavke !== pom_phase_to_select
      ) {
        let pomDateTime = this.date + "T" + this.time;
        let izabranoVreme = Date.parse(pomDateTime);

        if (izabranoVreme > this.datetime_action) {
          if (idPom === 0) {
            url =
              this.globalServiceLocation +
              this.globalPort +
              "/tank_phase_wine/decanting";

            this.$http
              .post(url, complexObject, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization:
                    "Bearer  " + localStorage.getItem("user-token"),
                },
              })
              .then((response) => {
                this.isLoading = false;

                if (response.data.isEmptyTank) {
                  this.kolicinaVina = 0;
                  this.isEmptyTank = true;
                } else {
                  this.kolicinaVina =
                    Number(this.kolicinaVinaPom) + Number(this.wine_quantity);
                }

                this.id_tank_phase_wine = response.data.toTankPhaseWineId;

                serverBus.$emit("refresh_coupage", this.id_tank_phase_wine);

                this.disabled_vine = true;

                if (Number(this.tip_vina_tank) !== 0)
                  this.wine_to_select = Number(this.tip_vina_tank);
                else {
                  this.tip_vina_tank = Number(pom_wine_to_select);
                }

                if (Number(pom_phase_to_select) !== 0)
                  this.faza = Number(pom_phase_to_select);
                else this.faza = Number(this.faza_izabrani_tank);

                if (typeof this.phase_to_select.phaseMark !== "undefined")
                  this.faza_mark = this.phase_to_select.phaseMark;

                if (typeof this.jm_dolivanja_select.mark !== "undefined")
                  this.jm_mark = this.jm_dolivanja_select.mark;

                this.clear();
              })
              .catch((e) => {
                if (!e.response) {
                  this.isLoading = false;

                  alert(
                    this.$t("error.message")
                  );
                } else {
                  if (e.response.status === 401) {
                    this.$refs.frmtoken
                      .osvezavanjeTokena(
                        localStorage.getItem("user-refresh-token")
                      )
                      .then((result) => {
                        this.$http
                          .post(url, complexObject, {
                            headers: {
                              "Content-Type": "application/json",
                              Authorization:
                                "Bearer  " + localStorage.getItem("user-token"),
                            },
                          })
                          .then((response) => {
                            this.isLoading = false;

                            if (response.data.isEmptyTank) {
                              this.kolicinaVina = 0;
                              this.isEmptyTank = true;
                            } else {
                              this.kolicinaVina =
                                Number(this.kolicinaVinaPom) +
                                Number(this.wine_quantity);
                            }

                            this.id_tank_phase_wine =
                              response.data.toTankPhaseWineId;

                            serverBus.$emit(
                              "refresh_coupage",
                              this.id_tank_phase_wine
                            );

                            this.disabled_vine = true;

                            if (Number(this.tip_vina_tank) !== 0)
                              this.wine_to_select = Number(this.tip_vina_tank);
                            else {
                              this.tip_vina_tank = Number(pom_wine_to_select);
                            }

                            if (Number(pom_phase_to_select) !== 0)
                              this.faza = Number(pom_phase_to_select);
                            else this.faza = Number(this.faza_izabrani_tank);

                            if (
                              typeof this.phase_to_select.phaseMark !==
                              "undefined"
                            )
                              this.faza_mark = this.phase_to_select.phaseMark;

                            if (
                              typeof this.jm_dolivanja_select.mark !==
                              "undefined"
                            )
                              this.jm_mark = this.jm_dolivanja_select.mark;

                            this.clear();
                          })
                          .catch((e) => {
                            this.isLoading = false;

                            let pomError = readJSON(e.response.data.message);
                            alert(pomError);
                          });
                      });
                  } else {
                    this.isLoading = false;

                    let pomError = readJSON(e.response.data.message);
                    alert(pomError);
                  }
                }
              });
          } else {
            url =
              this.globalServiceLocation +
              this.globalPort +
              "/tank_phase_wine/decanting/update/" +
              idPom;

            this.$http
              .put(url, complexObject, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization:
                    "Bearer  " + localStorage.getItem("user-token"),
                },
              })
              .then((response) => {
                this.isLoading = false;

                if (response.data.isEmptyTank) {
                  this.kolicinaVina = 0;
                  this.isEmptyTank = true;
                } else {
                  this.kolicinaVina =
                    Number(this.kolicinaVinaPom) + Number(this.wine_quantity);
                }

                // this.id_tank_phase_wine = response.data.toTankPhaseWineId;

                serverBus.$emit("refresh_coupage", this.id_tank_phase_wine);

                this.disabled_vine = true;

                if (Number(this.tip_vina_tank) !== 0)
                  this.wine_to_select = Number(this.tip_vina_tank);
                else {
                  this.tip_vina_tank = Number(pom_wine_to_select);
                }

                if (Number(pom_phase_to_select) !== 0)
                  this.faza = Number(pom_phase_to_select);
                else this.faza = Number(this.faza_izabrani_tank);

                if (typeof this.phase_to_select.phaseMark !== "undefined")
                  this.faza_mark = this.phase_to_select.phaseMark;

                if (typeof this.jm_dolivanja_select.mark !== "undefined")
                  this.jm_mark = this.jm_dolivanja_select.mark;

                this.clear();
              })
              .catch((e) => {
                if (!e.response) {
                  this.isLoading = false;

                  alert(
                    this.$t("error.message")
                  );
                } else {
                  if (e.response.status === 401) {
                    this.$refs.frmtoken
                      .osvezavanjeTokena(
                        localStorage.getItem("user-refresh-token")
                      )
                      .then((result) => {
                        this.$http
                          .put(url, complexObject, {
                            headers: {
                              "Content-Type": "application/json",
                              Authorization:
                                "Bearer  " + localStorage.getItem("user-token"),
                            },
                          })
                          .then((response) => {
                            this.isLoading = false;

                            if (response.data.isEmptyTank) {
                              this.kolicinaVina = 0;
                              this.isEmptyTank = true;
                            } else {
                              this.kolicinaVina =
                                Number(this.kolicinaVinaPom) +
                                Number(this.wine_quantity);
                            }

                            // this.id_tank_phase_wine = response.data.toTankPhaseWineId;

                            serverBus.$emit(
                              "refresh_coupage",
                              this.id_tank_phase_wine
                            );

                            this.disabled_vine = true;

                            if (Number(this.tip_vina_tank) !== 0)
                              this.wine_to_select = Number(this.tip_vina_tank);
                            else {
                              this.tip_vina_tank = Number(pom_wine_to_select);
                            }

                            if (Number(pom_phase_to_select) !== 0)
                              this.faza = Number(pom_phase_to_select);
                            else this.faza = Number(this.faza_izabrani_tank);

                            if (
                              typeof this.phase_to_select.phaseMark !==
                              "undefined"
                            )
                              this.faza_mark = this.phase_to_select.phaseMark;

                            if (
                              typeof this.jm_dolivanja_select.mark !==
                              "undefined"
                            )
                              this.jm_mark = this.jm_dolivanja_select.mark;

                            this.clear();
                          })
                          .catch((e) => {
                            this.isLoading = false;

                            let pomError = readJSON(e.response.data.message);
                            alert(pomError);
                          });
                      });
                  } else {
                    this.isLoading = false;

                    let pomError = readJSON(e.response.data.message);
                    alert(pomError);
                  }
                }
              });
          }
          // }
        } else {
          if (idPom === 0) {
            url =
              this.globalServiceLocation +
              this.globalPort +
              "/tank_phase_wine/decanting";

            this.$http
              .post(url, complexObject, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization:
                    "Bearer  " + localStorage.getItem("user-token"),
                },
              })
              .then((response) => {
                this.isLoading = false;

                if (response.data.isEmptyTank) {
                  this.kolicinaVina = 0;
                  this.isEmptyTank = true;
                } else {
                  this.kolicinaVina =
                    Number(this.kolicinaVinaPom) + Number(this.wine_quantity);
                }

                this.id_tank_phase_wine = response.data.toTankPhaseWineId;

                serverBus.$emit("refresh_coupage", this.id_tank_phase_wine);

                this.disabled_vine = true;

                if (Number(this.tip_vina_tank) !== 0)
                  this.wine_to_select = Number(this.tip_vina_tank);
                else {
                  this.tip_vina_tank = Number(pom_wine_to_select);
                }

                if (Number(pom_phase_to_select) !== 0)
                  this.faza = Number(pom_phase_to_select);
                else this.faza = Number(this.faza_izabrani_tank);

                if (typeof this.phase_to_select.phaseMark !== "undefined")
                  this.faza_mark = this.phase_to_select.phaseMark;

                if (typeof this.jm_dolivanja_select.mark !== "undefined")
                  this.jm_mark = this.jm_dolivanja_select.mark;

                this.clear();
              })
              .catch((e) => {
                if (!e.response) {
                  this.isLoading = false;

                  alert(
                    this.$t("error.message")
                  );
                } else {
                  if (e.response.status === 401) {
                    this.$refs.frmtoken
                      .osvezavanjeTokena(
                        localStorage.getItem("user-refresh-token")
                      )
                      .then((result) => {
                        this.$http
                          .post(url, complexObject, {
                            headers: {
                              "Content-Type": "application/json",
                              Authorization:
                                "Bearer  " + localStorage.getItem("user-token"),
                            },
                          })
                          .then((response) => {
                            this.isLoading = false;

                            if (response.data.isEmptyTank) {
                              this.kolicinaVina = 0;
                              this.isEmptyTank = true;
                            } else {
                              this.kolicinaVina =
                                Number(this.kolicinaVinaPom) +
                                Number(this.wine_quantity);
                            }

                            this.id_tank_phase_wine =
                              response.data.toTankPhaseWineId;

                            serverBus.$emit(
                              "refresh_coupage",
                              this.id_tank_phase_wine
                            );

                            this.disabled_vine = true;

                            if (Number(this.tip_vina_tank) !== 0)
                              this.wine_to_select = Number(this.tip_vina_tank);
                            else {
                              this.tip_vina_tank = Number(pom_wine_to_select);
                            }

                            if (Number(pom_phase_to_select) !== 0)
                              this.faza = Number(pom_phase_to_select);
                            else this.faza = Number(this.faza_izabrani_tank);

                            if (
                              typeof this.phase_to_select.phaseMark !==
                              "undefined"
                            )
                              this.faza_mark = this.phase_to_select.phaseMark;

                            if (
                              typeof this.jm_dolivanja_select.mark !==
                              "undefined"
                            )
                              this.jm_mark = this.jm_dolivanja_select.mark;

                            this.clear();
                          })
                          .catch((e) => {
                            this.isLoading = false;

                            let pomError = readJSON(e.response.data.message);
                            alert(pomError);
                          });
                      });
                  } else {
                    this.isLoading = false;

                    let pomError = readJSON(e.response.data.message);
                    alert(pomError);
                  }
                }
              });
          } else {
            url =
              this.globalServiceLocation +
              this.globalPort +
              "/tank_phase_wine/decanting/update/" +
              idPom;

            this.$http
              .put(url, complexObject, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization:
                    "Bearer  " + localStorage.getItem("user-token"),
                },
              })
              .then((response) => {
                this.isLoading = false;

                if (response.data.isEmptyTank) {
                  this.kolicinaVina = 0;
                  this.isEmptyTank = true;
                } else {
                  this.kolicinaVina =
                    Number(this.kolicinaVinaPom) + Number(this.wine_quantity);
                }

                // this.id_tank_phase_wine = response.data.toTankPhaseWineId;

                serverBus.$emit("refresh_coupage", this.id_tank_phase_wine);

                this.disabled_vine = true;

                if (Number(this.tip_vina_tank) !== 0)
                  this.wine_to_select = Number(this.tip_vina_tank);
                else {
                  this.tip_vina_tank = Number(pom_wine_to_select);
                }

                if (Number(pom_phase_to_select) !== 0)
                  this.faza = Number(pom_phase_to_select);
                else this.faza = Number(this.faza_izabrani_tank);

                if (typeof this.phase_to_select.phaseMark !== "undefined")
                  this.faza_mark = this.phase_to_select.phaseMark;

                if (typeof this.jm_dolivanja_select.mark !== "undefined")
                  this.jm_mark = this.jm_dolivanja_select.mark;

                this.clear();
              })
              .catch((e) => {
                if (!e.response) {
                  this.isLoading = false;

                  alert(
                    this.$t("error.message")
                  );
                } else {
                  if (e.response.status === 401) {
                    this.$refs.frmtoken
                      .osvezavanjeTokena(
                        localStorage.getItem("user-refresh-token")
                      )
                      .then((result) => {
                        this.$http
                          .put(url, complexObject, {
                            headers: {
                              "Content-Type": "application/json",
                              Authorization:
                                "Bearer  " + localStorage.getItem("user-token"),
                            },
                          })
                          .then((response) => {
                            this.isLoading = false;

                            if (response.data.isEmptyTank) {
                              this.kolicinaVina = 0;
                              this.isEmptyTank = true;
                            } else {
                              this.kolicinaVina =
                                Number(this.kolicinaVinaPom) +
                                Number(this.wine_quantity);
                            }

                            // this.id_tank_phase_wine = response.data.toTankPhaseWineId;

                            serverBus.$emit(
                              "refresh_coupage",
                              this.id_tank_phase_wine
                            );

                            this.disabled_vine = true;

                            if (Number(this.tip_vina_tank) !== 0)
                              this.wine_to_select = Number(this.tip_vina_tank);
                            else {
                              this.tip_vina_tank = Number(pom_wine_to_select);
                            }

                            if (Number(pom_phase_to_select) !== 0)
                              this.faza = Number(pom_phase_to_select);
                            else this.faza = Number(this.faza_izabrani_tank);

                            if (
                              typeof this.phase_to_select.phaseMark !==
                              "undefined"
                            )
                              this.faza_mark = this.phase_to_select.phaseMark;

                            if (
                              typeof this.jm_dolivanja_select.mark !==
                              "undefined"
                            )
                              this.jm_mark = this.jm_dolivanja_select.mark;

                            this.clear();
                          })
                          .catch((e) => {
                            this.isLoading = false;

                            let pomError = readJSON(e.response.data.message);
                            alert(pomError);
                          });
                      });
                  } else {
                    this.isLoading = false;

                    let pomError = readJSON(e.response.data.message);
                    alert(pomError);
                  }
                }
              });
          }
        }
      } else {
        if (idPom === 0) {
          url =
            this.globalServiceLocation +
            this.globalPort +
            "/tank_phase_wine/decanting";
          this.$http
            .post(url, complexObject, {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer  " + localStorage.getItem("user-token"),
              },
            })
            .then((response) => {
              this.isLoading = false;

              if (response.data.isEmptyTank) {
                this.kolicinaVina = 0;
                this.isEmptyTank = true;
              } else {
                this.kolicinaVina =
                  Number(this.kolicinaVinaPom) + Number(this.wine_quantity);
              }

              this.id_tank_phase_wine = response.data.toTankPhaseWineId;

              serverBus.$emit("refresh_coupage", this.id_tank_phase_wine);

              this.clear();
            })
            .catch((e) => {
              if (!e.response) {
                this.isLoading = false;

                alert(
                  this.$t("error.message")
                );
              } else {
                if (e.response.status === 401) {
                  this.$refs.frmtoken
                    .osvezavanjeTokena(
                      localStorage.getItem("user-refresh-token")
                    )
                    .then((result) => {
                      this.$http
                        .post(url, complexObject, {
                          headers: {
                            "Content-Type": "application/json",
                            Authorization:
                              "Bearer  " + localStorage.getItem("user-token"),
                          },
                        })
                        .then((response) => {
                          this.isLoading = false;

                          if (response.data.isEmptyTank) {
                            this.kolicinaVina = 0;
                            this.isEmptyTank = true;
                          } else {
                            this.kolicinaVina =
                              Number(this.kolicinaVinaPom) +
                              Number(this.wine_quantity);
                          }

                          this.id_tank_phase_wine =
                            response.data.toTankPhaseWineId;

                          serverBus.$emit(
                            "refresh_coupage",
                            this.id_tank_phase_wine
                          );

                          this.clear();
                        })
                        .catch((e) => {
                          this.isLoading = false;

                          let pomError = readJSON(e.response.data.message);
                          alert(pomError);
                        });
                    });
                } else {
                  this.isLoading = false;

                  let pomError = readJSON(e.response.data.message);
                  alert(pomError);
                }
              }
            });
        } else {
          url =
            this.globalServiceLocation +
            this.globalPort +
            "/tank_phase_wine/decanting/update/" +
            idPom;

          this.$http
            .put(url, complexObject, {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer  " + localStorage.getItem("user-token"),
              },
            })
            .then((response) => {
              this.isLoading = false;

              if (response.data.isEmptyTank) {
                this.kolicinaVina = 0;
                this.isEmptyTank = true;
              } else {
                this.kolicinaVina =
                  Number(this.kolicinaVinaPom) + Number(this.wine_quantity);
              }

              // this.id_tank_phase_wine = response.data.toTankPhaseWineId;

              serverBus.$emit("refresh_coupage", this.id_tank_phase_wine);

              this.clear();
            })
            .catch((e) => {
              if (!e.response) {
                this.isLoading = false;

                alert(
                  this.$t("error.message")
                );
              } else {
                if (e.response.status === 401) {
                  this.$refs.frmtoken
                    .osvezavanjeTokena(
                      localStorage.getItem("user-refresh-token")
                    )
                    .then((result) => {
                      this.$http
                        .put(url, complexObject, {
                          headers: {
                            "Content-Type": "application/json",
                            Authorization:
                              "Bearer  " + localStorage.getItem("user-token"),
                          },
                        })
                        .then((response) => {
                          this.isLoading = false;

                          if (response.data.isEmptyTank) {
                            this.kolicinaVina = 0;
                            this.isEmptyTank = true;
                          } else {
                            this.kolicinaVina =
                              Number(this.kolicinaVinaPom) +
                              Number(this.wine_quantity);
                          }

                          // this.id_tank_phase_wine = response.data.toTankPhaseWineId;

                          serverBus.$emit(
                            "refresh_coupage",
                            this.id_tank_phase_wine
                          );

                          this.clear();
                        })
                        .catch((e) => {
                          this.isLoading = false;

                          let pomError = readJSON(e.response.data.message);
                          alert(pomError);
                        });
                    });
                } else {
                  this.isLoading = false;

                  let pomError = readJSON(e.response.data.message);
                  alert(pomError);
                }
              }
            });
        }
      }
    },
    PreostaloUTanku_novo(idTank) {
      if (typeof idTank !== "undefined" && idTank !== 0)
        this.$http
          .get(
            this.globalServiceLocation +
              this.globalPort +
              "/tank/" +
              idTank +
              "/free_space",
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer  " + localStorage.getItem("user-token"),
              },
            }
          )
          .then((response) => {
            this.preostalo_izabrani_tank_prazan = response.data.tankCapacity;
            this.preostalo_izabrani_tank_prazan_jm =
              response.data.unitOfMeasure.mark;
          })
          .catch((e) => {
            if (!e.response) {
              alert(
                this.$t("error.message")
              );
            } else {
              if (e.response.status === 401) {
                this.$refs.frmtoken
                  .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                  .then((result) => {
                    this.$http
                      .get(
                        this.globalServiceLocation +
                          this.globalPort +
                          "/tank/" +
                          idTank +
                          "/free_space",
                        {
                          headers: {
                            "Content-Type": "application/json",
                            Authorization:
                              "Bearer  " + localStorage.getItem("user-token"),
                          },
                        }
                      )
                      .then((response) => {
                        this.preostalo_izabrani_tank_prazan =
                          response.data.freeSpaceInTank;
                        this.preostalo_izabrani_tank_prazan_jm =
                          response.data.unitOfMeasure.mark;
                      })
                      .catch((e) => {
                        let pomError = readJSON(e.response.data.message);
                        alert(pomError);
                      });
                  });
              } else {
                let pomError = readJSON(e.response.data.message);
                alert(pomError);
              }
            }
          });
    },
    PreostaloUTanku(idTank) {
      

      if (
        typeof idTank !== "undefined" &&
        typeof idTank !== "object" &&
        idTank !== 0
      )
        this.$http
          .get(
            this.globalServiceLocation +
              this.globalPort +
              "/tank/" +
              idTank +
              "/free_space",
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer  " + localStorage.getItem("user-token"),
              },
            }
          )
          .then((response) => {
            if (this.wine_quantity === undefined)
              this.preostalo_izabrani_tank =
                response.data.tankCapacity - response.data.freeSpaceInTank;
            else {
              let s_q = 0;
              if (this.sediment_quantity !== undefined)
                s_q = Number(this.sediment_quantity);

              let o_q = 0;
              if (this.sediment_quantity !== undefined)
                o_q = Number(this.outage_quantity);

              this.preostalo_izabrani_tank =
                response.data.tankCapacity -
                response.data.freeSpaceInTank +
                Number(this.wine_quantity) +
                s_q +
                o_q;
            }

            this.id_jedinica_mere = response.data.unitOfMeasure.id;
            this.preostalo_izabrani_tank_jm = response.data.unitOfMeasure.mark;

            if (response.data.phase !== null) {
              this.faza_izabrani_tank = response.data.phase.id;
              this.tip_vina_izabrani_tank_pom = response.data.wineId;
            } else {
              this.faza_izabrani_tank = null;
              this.tip_vina_izabrani_tank_pom = null;
            }
          })
          .catch((e) => {
            if (!e.response) {
              alert(
                this.$t("error.message")
              );
            } else {
              if (e.response.status === 401) {
                this.$refs.frmtoken
                  .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                  .then((result) => {
                    this.$http
                      .get(
                        this.globalServiceLocation +
                          this.globalPort +
                          "/tank/" +
                          idTank +
                          "/free_space",
                        {
                          headers: {
                            "Content-Type": "application/json",
                            Authorization:
                              "Bearer  " + localStorage.getItem("user-token"),
                          },
                        }
                      )
                      .then((response) => {
                        if (this.wine_quantity === undefined)
                          this.preostalo_izabrani_tank =
                            response.data.tankCapacity -
                            response.data.freeSpaceInTank;
                        else {
                          let s_q = 0;
                          if (this.sediment_quantity !== undefined)
                            s_q = Number(this.sediment_quantity);

                          let o_q = 0;
                          if (this.sediment_quantity !== undefined)
                            o_q = Number(this.outage_quantity);

                          this.preostalo_izabrani_tank =
                            response.data.tankCapacity -
                            response.data.freeSpaceInTank +
                            Number(this.wine_quantity) +
                            s_q +
                            o_q;
                        }

                        this.id_jedinica_mere = response.data.unitOfMeasure.id;
                        this.preostalo_izabrani_tank_jm =
                          response.data.unitOfMeasure.mark;

                        // alert(this.preostalo_izabrani_tank);

                        if (response.data.phase !== null) {
                          this.faza_izabrani_tank = response.data.phase.id;
                          this.tip_vina_izabrani_tank_pom =
                            response.data.wineId;
                        } else {
                          this.faza_izabrani_tank = null;
                          this.tip_vina_izabrani_tank_pom = null;
                        }
                      })
                      .catch((e) => {
                        let pomError = readJSON(e.response.data.message);
                        alert(pomError);
                      });
                  });
              } else {
                let pomError = readJSON(e.response.data.message);
                alert(pomError);
              }
            }
          });
    },
    changeRoute(a) {
      if (typeof a !== "undefined") {
        if (a.id === undefined) {
          if (a !== undefined) {
            if (a.name !== undefined) {
              this.wineType(a);

              let enumLable = this.tank_to_items.find(
                (x) => x.tankPhaseWineId === a
              ).enumLable;

              if (enumLable === "press") this.tekst_labele_1 = "Komina";
              else this.tekst_labele_1 = "Taloga";
            } else {
              this.PreostaloUTanku(a);
              this.wineType(a);
              this.tekst_labele_1 = "Taloga";
            }
          } else if (typeof this.tank_to_select === "undefined")
            this.tank_to_select = "undefined";
        } else {
          this.PreostaloUTanku(a.id);
          this.wineType(a.id);

          let enumLable = this.tank_to_items.find(
            (x) => x.id === a.id
          ).enumLable;

          if (enumLable === "press") this.tekst_labele_1 = "Komina";
          else this.tekst_labele_1 = "Taloga";
        }
      }
    },
    changeSifarnik() {
      let kolicinaVina = Number(this.kolicinaVina);
      let wine_quantity = Number(this.wine_quantity);

      var pom_phase_to_select;

      if (typeof this.phase_to_select !== "undefined")
        if (typeof this.phase_to_select.id !== "undefined")
          if (this.phase_to_select.id === null)
            pom_phase_to_select = this.phase_to_select;
          else pom_phase_to_select = this.phase_to_select.id;
        else pom_phase_to_select = this.phase_to_select;

      if (Number(wine_quantity) === 0) {
        this.isLoading = false;
        alert("Uneta količina ne sme imati vrednost nula.");
      } else if (true == true)
        if (this.isEmptyTank) {
          this.isLoading = false;
          alert("Izabrani tank je prazan");
        } else if (
          typeof this.wine_to_select === "undefined" &&
          this.tip_vina_izabrani_tank_pom !== this.tip_vina_tank &&
          this.tip_vina_izabrani_tank_pom !== null &&
          typeof this.tip_vina_izabrani_tank_pom !== "undefined"
        ) {
          this.isLoading = false;
          alert("U tankovima se ne nalazi isto vino, morate navesti novo vino");
        } else if (
          Number(this.faza) !== 0 &&
          Number(this.faza_izabrani_tank) !== Number(this.faza) &&
          typeof pom_phase_to_select === "undefined" &&
          this.faza_izabrani_tank !== null
        ) {
          this.isLoading = false;
          alert(
            "Kupažiranje nije moguće, izabrani tankovi se ne nalaze u istoj fazi"
          );
        } else if (
          Number(this.sediment_quantity) === 0 ||
          typeof this.sediment_quantity === "undefined" ||
          this.sediment_quantity === ""
        ) {
          var complexObject;
          var pom_jm_dolivanja_select;

          if (this.jm_dolivanja_select === null) pom_jm_dolivanja_select = "0";
          else if (typeof this.jm_dolivanja_select === "undefined")
            pom_jm_dolivanja_select = "0";
          else if (this.jm_dolivanja_select.id == null)
            pom_jm_dolivanja_select = this.jm_dolivanja_select;
          else pom_jm_dolivanja_select = this.jm_dolivanja_select.id;

          var pom_jm_outage_select;

          if (this.jm_outage_select === null) pom_jm_outage_select = "0";
          else if (typeof this.jm_outage_select === "undefined")
            pom_jm_outage_select = "0";
          else if (this.jm_outage_select.id == null)
            pom_jm_outage_select = this.jm_outage_select;
          else pom_jm_outage_select = this.jm_outage_select.id;

          var pom_tank_to_select;

          if (this.tank_to_select.tankPhaseWineId == null)
            pom_tank_to_select = this.tank_to_select;
          else pom_tank_to_select = this.tank_to_select.tankPhaseWineId;

          var pom_wine_to_select;
          if (typeof this.wine_to_select !== "undefined")
            if (typeof this.wine_to_select.id !== "undefined")
              if (this.wine_to_select.id == null)
                pom_wine_to_select = this.wine_to_select;
              else pom_wine_to_select = this.wine_to_select.id;
            else pom_wine_to_select = this.wine_to_select;

          if (
            Number(this.outage_quantity) === 0 ||
            typeof this.outage_quantity === "undefined" ||
            this.outage_quantity === ""
          ) {
            if (
              typeof this.wine_to_select !== "undefined" &&
              this.tip_vina_izabrani_tank_pom !== null &&
              typeof this.tip_vina_izabrani_tank_pom !== "undefined" &&
              this.tip_vina_izabrani_tank_pom !== this.tip_vina_tank
            )
              if (
                this.faza_izabrani_tank !== null &&
                typeof this.faza_izabrani_tank !== "undefined" &&
                typeof pom_phase_to_select !== "undefined" &&
                Number(pom_phase_to_select) !== 0
              )
                complexObject = {
                  id: this.ID,
                  tankPhaseWineId: pom_tank_to_select,
                  toTankId: this.id_tank,
                  toPhaseId: pom_phase_to_select,
                  toWineId: pom_wine_to_select,
                  decantingDate: this.date + "T" + this.time,
                  quantity: Number(this.wine_quantity),
                  // sediment: 0,
                  // outage: 0,
                  quantityUnitOfMeasureId: pom_jm_dolivanja_select,
                  // sedimentUnitOfMeasureId: null,
                  // outageUnitOfMeasureId: null,
                  description: this.opis,
                };
              else
                complexObject = {
                  id: this.ID,
                  tankPhaseWineId: pom_tank_to_select,
                  toTankId: this.id_tank,
                  // toPhaseId: pom_phase_to_select,
                  toWineId: pom_wine_to_select,
                  decantingDate: this.date + "T" + this.time,
                  quantity: Number(this.wine_quantity),
                  // sediment: 0,
                  // outage: 0,
                  quantityUnitOfMeasureId: pom_jm_dolivanja_select,
                  // sedimentUnitOfMeasureId: null,
                  // outageUnitOfMeasureId: null,
                  description: this.opis,
                };
            else if (
              this.faza_izabrani_tank !== null &&
              typeof this.faza_izabrani_tank !== "undefined" &&
              typeof pom_phase_to_select !== "undefined" &&
              Number(pom_phase_to_select) !== 0
            )
              complexObject = {
                id: this.ID,
                tankPhaseWineId: pom_tank_to_select,
                toTankId: this.id_tank,
                toPhaseId: pom_phase_to_select,
                toWineId: pom_wine_to_select,
                decantingDate: this.date + "T" + this.time,
                quantity: Number(this.wine_quantity),
                // sediment: 0,
                // outage: 0,
                quantityUnitOfMeasureId: pom_jm_dolivanja_select,
                // sedimentUnitOfMeasureId: null,
                // outageUnitOfMeasureId: null,
                description: this.opis,
              };
            else
              complexObject = {
                id: this.ID,
                tankPhaseWineId: pom_tank_to_select,
                toTankId: this.id_tank,
                // toPhaseId: pom_phase_to_select,
                toWineId: pom_wine_to_select,
                decantingDate: this.date + "T" + this.time,
                quantity: Number(this.wine_quantity),
                // sediment: 0,
                // outage: 0,
                quantityUnitOfMeasureId: pom_jm_dolivanja_select,
                // sedimentUnitOfMeasureId: null,
                // outageUnitOfMeasureId: null,
                description: this.opis,
              };
          } else if (
            typeof this.wine_to_select !== "undefined" &&
            this.tip_vina_izabrani_tank_pom !== null &&
            typeof this.tip_vina_izabrani_tank_pom !== "undefined" &&
            this.tip_vina_izabrani_tank_pom !== this.tip_vina_tank
          )
            if (
              this.faza_izabrani_tank !== null &&
              typeof this.faza_izabrani_tank !== "undefined" &&
              typeof pom_phase_to_select !== "undefined" &&
              Number(pom_phase_to_select) !== 0
            )
              complexObject = {
                id: this.ID,
                tankPhaseWineId: pom_tank_to_select,
                toTankId: this.id_tank,
                toPhaseId: pom_phase_to_select,
                toWineId: pom_wine_to_select,
                decantingDate: this.date + "T" + this.time,
                quantity: Number(this.wine_quantity),
                // sediment: 0,
                outage: this.outage_quantity,
                quantityUnitOfMeasureId: pom_jm_dolivanja_select,
                // sedimentUnitOfMeasureId: null,
                outageUnitOfMeasureId: pom_jm_outage_select,
                description: this.opis,
              };
            else
              complexObject = {
                id: this.ID,
                tankPhaseWineId: pom_tank_to_select,
                toTankId: this.id_tank,
                // toPhaseId: pom_phase_to_select,
                toWineId: pom_wine_to_select,
                decantingDate: this.date + "T" + this.time,
                quantity: Number(this.wine_quantity),
                // sediment: 0,
                outage: this.outage_quantity,
                quantityUnitOfMeasureId: pom_jm_dolivanja_select,
                // sedimentUnitOfMeasureId: null,
                outageUnitOfMeasureId: pom_jm_outage_select,
                description: this.opis,
              };
          else if (
            this.faza_izabrani_tank !== null &&
            typeof this.faza_izabrani_tank !== "undefined" &&
            typeof pom_phase_to_select !== "undefined" &&
            Number(pom_phase_to_select) !== 0
          )
            complexObject = {
              id: this.ID,
              tankPhaseWineId: pom_tank_to_select,
              toTankId: this.id_tank,
              toPhaseId: pom_phase_to_select,
              toWineId: pom_wine_to_select,
              decantingDate: this.date + "T" + this.time,
              quantity: Number(this.wine_quantity),
              // sediment: 0,
              outage: this.outage_quantity,
              quantityUnitOfMeasureId: pom_jm_dolivanja_select,
              // sedimentUnitOfMeasureId: null,
              outageUnitOfMeasureId: pom_jm_outage_select,
              description: this.opis,
            };
          else
            complexObject = {
              id: this.ID,
              tankPhaseWineId: pom_tank_to_select,
              toTankId: this.id_tank,
              // toPhaseId: pom_phase_to_select,
              toWineId: pom_wine_to_select,
              decantingDate: this.date + "T" + this.time,
              quantity: Number(this.wine_quantity),
              // sediment: 0,
              outage: this.outage_quantity,
              quantityUnitOfMeasureId: pom_jm_dolivanja_select,
              // sedimentUnitOfMeasureId: null,
              outageUnitOfMeasureId: pom_jm_outage_select,
              description: this.opis,
            };

          if (
            typeof pom_phase_to_select !== "undefined" &&
            this.prethodna_faza_stavke !== pom_phase_to_select
          ) {
            let pomDateTime = this.date + "T" + this.time;
            let izabranoVreme = Date.parse(pomDateTime);

            if (izabranoVreme > this.datetime_action) {
              if (
                confirm(
                  "Da li ste sigurni da želite promenu faze na dan " +
                    this.date +
                    "?"
                )
              ) {
                this.$http
                  .put(
                    this.globalServiceLocation +
                      this.globalPort +
                      "/tank_phase_wine/decanting/update/" +
                      this.ID,
                    complexObject,
                    {
                      headers: {
                        "Content-Type": "application/json",
                        Authorization:
                          "Bearer  " + localStorage.getItem("user-token"),
                      },
                    }
                  )
                  .then((response) => {
                    this.isLoading = false;

                    if (response.data.isEmptyTank) {
                      this.kolicinaVina = 0;
                      this.isEmptyTank = true;
                    } else {
                      this.kolicinaVina =
                        Number(this.kolicinaVinaPom) +
                        Number(this.wine_quantity);
                    }

                    serverBus.$emit("refresh_coupage", this.id_tank_phase_wine);

                    if (Number(pom_phase_to_select) !== 0)
                      this.faza = Number(pom_phase_to_select);
                    else this.faza = Number(this.faza_izabrani_tank);

                    if (typeof this.phase_to_select.phaseMark !== "undefined")
                      this.faza_mark = this.phase_to_select.phaseMark;

                    if (typeof this.jm_dolivanja_select.mark !== "undefined")
                      this.jm_mark = this.jm_dolivanja_select.mark;

                    this.clear();
                  })
                  .catch((e) => {
                    if (!e.response) {
                      this.isLoading = false;

                      alert(
                        this.$t("error.message")
                      );
                    } else {
                      if (e.response.status === 401) {
                        this.$refs.frmtoken
                          .osvezavanjeTokena(
                            localStorage.getItem("user-refresh-token")
                          )
                          .then((result) => {
                            this.$http
                              .put(
                                this.globalServiceLocation +
                                  this.globalPort +
                                  "/tank_phase_wine/decanting/update/" +
                                  this.ID,
                                complexObject,
                                {
                                  headers: {
                                    "Content-Type": "application/json",
                                    Authorization:
                                      "Bearer  " +
                                      localStorage.getItem("user-token"),
                                  },
                                }
                              )
                              .then((response) => {
                                this.isLoading = false;

                                if (response.data.isEmptyTank) {
                                  this.kolicinaVina = 0;
                                  this.isEmptyTank = true;
                                } else {
                                  this.kolicinaVina =
                                    Number(this.kolicinaVinaPom) +
                                    Number(this.wine_quantity);
                                }

                                serverBus.$emit(
                                  "refresh_coupage",
                                  this.id_tank_phase_wine
                                );

                                if (Number(pom_phase_to_select) !== 0)
                                  this.faza = Number(pom_phase_to_select);
                                else
                                  this.faza = Number(this.faza_izabrani_tank);

                                if (
                                  typeof this.phase_to_select.phaseMark !==
                                  "undefined"
                                )
                                  this.faza_mark =
                                    this.phase_to_select.phaseMark;

                                if (
                                  typeof this.jm_dolivanja_select.mark !==
                                  "undefined"
                                )
                                  this.jm_mark = this.jm_dolivanja_select.mark;

                                this.clear();
                              })
                              .catch((e) => {
                                this.isLoading = false;

                                let pomError = readJSON(
                                  e.response.data.message
                                );
                                alert(pomError);
                              });
                          });
                      } else {
                        this.isLoading = false;

                        let pomError = readJSON(e.response.data.message);
                        alert(pomError);
                      }
                    }
                  });
              } else this.isLoading = false;
            } else if (
              confirm(
                "Da li ste sigurni da želite promenu faze na dan " +
                  this.date +
                  "?"
              )
            ) {
              this.$http
                .put(
                  this.globalServiceLocation +
                    this.globalPort +
                    "/tank_phase_wine/decanting/update/" +
                    this.ID,
                  complexObject,
                  {
                    headers: {
                      "Content-Type": "application/json",
                      Authorization:
                        "Bearer  " + localStorage.getItem("user-token"),
                    },
                  }
                )
                .then((response) => {
                  this.isLoading = false;

                  if (response.data.isEmptyTank) {
                    this.kolicinaVina = 0;
                    this.isEmptyTank = true;
                  } else {
                    this.kolicinaVina =
                      Number(this.kolicinaVinaPom) + Number(this.wine_quantity);
                  }
                  serverBus.$emit("refresh_coupage", this.id_tank_phase_wine);

                  if (Number(pom_phase_to_select) !== 0)
                    this.faza = Number(pom_phase_to_select);
                  else this.faza = Number(this.faza_izabrani_tank);

                  if (typeof this.phase_to_select.phaseMark !== "undefined")
                    this.faza_mark = this.phase_to_select.phaseMark;

                  if (typeof this.jm_dolivanja_select.mark !== "undefined")
                    this.jm_mark = this.jm_dolivanja_select.mark;

                  this.clear();
                })
                .catch((e) => {
                  if (!e.response) {
                    this.isLoading = false;

                    alert(
                      this.$t("error.message")
                    );
                  } else {
                    if (e.response.status === 401) {
                      this.$refs.frmtoken
                        .osvezavanjeTokena(
                          localStorage.getItem("user-refresh-token")
                        )
                        .then((result) => {
                          this.$http
                            .put(
                              this.globalServiceLocation +
                                this.globalPort +
                                "/tank_phase_wine/decanting/update/" +
                                this.ID,
                              complexObject,
                              {
                                headers: {
                                  "Content-Type": "application/json",
                                  Authorization:
                                    "Bearer  " +
                                    localStorage.getItem("user-token"),
                                },
                              }
                            )
                            .then((response) => {
                              this.isLoading = false;

                              if (response.data.isEmptyTank) {
                                this.kolicinaVina = 0;
                                this.isEmptyTank = true;
                              } else {
                                this.kolicinaVina =
                                  Number(this.kolicinaVinaPom) +
                                  Number(this.wine_quantity);
                              }
                              serverBus.$emit(
                                "refresh_coupage",
                                this.id_tank_phase_wine
                              );

                              if (Number(pom_phase_to_select) !== 0)
                                this.faza = Number(pom_phase_to_select);
                              else this.faza = Number(this.faza_izabrani_tank);

                              if (
                                typeof this.phase_to_select.phaseMark !==
                                "undefined"
                              )
                                this.faza_mark = this.phase_to_select.phaseMark;

                              if (
                                typeof this.jm_dolivanja_select.mark !==
                                "undefined"
                              )
                                this.jm_mark = this.jm_dolivanja_select.mark;

                              this.clear();
                            })
                            .catch((e) => {
                              this.isLoading = false;

                              let pomError = readJSON(e.response.data.message);
                              alert(pomError);
                            });
                        });
                    } else {
                      this.isLoading = false;

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    }
                  }
                });
            } else {
              this.$http
                .put(
                  this.globalServiceLocation +
                    this.globalPort +
                    "/tank_phase_wine/decanting/update/" +
                    this.ID,
                  complexObject,
                  {
                    headers: {
                      "Content-Type": "application/json",
                      Authorization:
                        "Bearer  " + localStorage.getItem("user-token"),
                    },
                  }
                )
                .then((response) => {
                  this.isLoading = false;

                  if (response.data.isEmptyTank) {
                    this.kolicinaVina = 0;
                    this.isEmptyTank = true;
                  } else {
                    this.kolicinaVina =
                      Number(this.kolicinaVinaPom) + Number(this.wine_quantity);
                  }

                  serverBus.$emit("refresh_coupage", this.id_tank_phase_wine);

                  if (Number(pom_phase_to_select) !== 0)
                    this.faza = Number(pom_phase_to_select);
                  else this.faza = Number(this.faza_izabrani_tank);

                  if (typeof this.phase_to_select.phaseMark !== "undefined")
                    this.faza_mark = this.phase_to_select.phaseMark;

                  if (typeof this.jm_dolivanja_select.mark !== "undefined")
                    this.jm_mark = this.jm_dolivanja_select.mark;

                  this.clear();
                })
                .catch((e) => {
                  if (!e.response) {
                    this.isLoading = false;

                    alert(
                      this.$t("error.message")
                    );
                  } else {
                    if (e.response.status === 401) {
                      this.$refs.frmtoken
                        .osvezavanjeTokena(
                          localStorage.getItem("user-refresh-token")
                        )
                        .then((result) => {
                          this.$http
                            .put(
                              this.globalServiceLocation +
                                this.globalPort +
                                "/tank_phase_wine/decanting/update/" +
                                this.ID,
                              complexObject,
                              {
                                headers: {
                                  "Content-Type": "application/json",
                                  Authorization:
                                    "Bearer  " +
                                    localStorage.getItem("user-token"),
                                },
                              }
                            )
                            .then((response) => {
                              this.isLoading = false;

                              if (response.data.isEmptyTank) {
                                this.kolicinaVina = 0;
                                this.isEmptyTank = true;
                              } else {
                                this.kolicinaVina =
                                  Number(this.kolicinaVinaPom) +
                                  Number(this.wine_quantity);
                              }

                              serverBus.$emit(
                                "refresh_coupage",
                                this.id_tank_phase_wine
                              );

                              if (Number(pom_phase_to_select) !== 0)
                                this.faza = Number(pom_phase_to_select);
                              else this.faza = Number(this.faza_izabrani_tank);

                              if (
                                typeof this.phase_to_select.phaseMark !==
                                "undefined"
                              )
                                this.faza_mark = this.phase_to_select.phaseMark;

                              if (
                                typeof this.jm_dolivanja_select.mark !==
                                "undefined"
                              )
                                this.jm_mark = this.jm_dolivanja_select.mark;

                              this.clear();
                            })
                            .catch((e) => {
                              this.isLoading = false;

                              let pomError = readJSON(e.response.data.message);
                              alert(pomError);
                            });
                        });
                    } else {
                      this.isLoading = false;

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    }
                  }
                });
            }
          } else {
            this.$http
              .put(
                this.globalServiceLocation +
                  this.globalPort +
                  "/tank_phase_wine/decanting/update/" +
                  this.ID,
                complexObject,
                {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization:
                      "Bearer  " + localStorage.getItem("user-token"),
                  },
                }
              )
              .then((response) => {
                this.isLoading = false;

                if (response.data.isEmptyTank) {
                  this.kolicinaVina = 0;
                  this.isEmptyTank = true;
                } else {
                  this.kolicinaVina =
                    Number(this.kolicinaVinaPom) + Number(this.wine_quantity);
                }

                serverBus.$emit("refresh_coupage", this.id_tank_phase_wine);

                if (Number(pom_phase_to_select) !== 0)
                  this.faza = Number(pom_phase_to_select);
                else this.faza = Number(this.faza_izabrani_tank);

                if (typeof this.phase_to_select.phaseMark !== "undefined")
                  this.faza_mark = this.phase_to_select.phaseMark;

                if (typeof this.jm_dolivanja_select.mark !== "undefined")
                  this.jm_mark = this.jm_dolivanja_select.mark;

                this.clear();
              })
              .catch((e) => {
                if (!e.response) {
                  this.isLoading = false;
                  alert(
                    this.$t("error.message")
                  );
                } else {
                  if (e.response.status === 401) {
                    this.$refs.frmtoken
                      .osvezavanjeTokena(
                        localStorage.getItem("user-refresh-token")
                      )
                      .then((result) => {
                        this.$http
                          .put(
                            this.globalServiceLocation +
                              this.globalPort +
                              "/tank_phase_wine/decanting/update/" +
                              this.ID,
                            complexObject,
                            {
                              headers: {
                                "Content-Type": "application/json",
                                Authorization:
                                  "Bearer  " +
                                  localStorage.getItem("user-token"),
                              },
                            }
                          )
                          .then((response) => {
                            this.isLoading = false;

                            if (response.data.isEmptyTank) {
                              this.kolicinaVina = 0;
                              this.isEmptyTank = true;
                            } else {
                              this.kolicinaVina =
                                Number(this.kolicinaVinaPom) +
                                Number(this.wine_quantity);
                            }

                            serverBus.$emit(
                              "refresh_coupage",
                              this.id_tank_phase_wine
                            );

                            if (Number(pom_phase_to_select) !== 0)
                              this.faza = Number(pom_phase_to_select);
                            else this.faza = Number(this.faza_izabrani_tank);

                            if (
                              typeof this.phase_to_select.phaseMark !==
                              "undefined"
                            )
                              this.faza_mark = this.phase_to_select.phaseMark;

                            if (
                              typeof this.jm_dolivanja_select.mark !==
                              "undefined"
                            )
                              this.jm_mark = this.jm_dolivanja_select.mark;

                            this.clear();
                          })
                          .catch((e) => {
                            this.isLoading = false;

                            let pomError = readJSON(e.response.data.message);
                            alert(pomError);
                          });
                      });
                  } else {
                    this.isLoading = false;

                    let pomError = readJSON(e.response.data.message);
                    alert(pomError);
                  }
                }
              });
          }
        } else {
          // var ukupanIznos =
          //   parseFloat(this.wine_quantity) +
          //   parseFloat(this.sediment_quantity) +
          //   parseFloat(this.outage_quantity);
          // if (parseFloat(this.preostalo_izabrani_tank) !== ukupanIznos) {
          //   alert(
          //     "Uneli ste talog, a ukupna zbir količine vina koja se pretače, rastura i taloga je različita od količine vina u bačvi."
          //   );
          // } else
          this.Pretakanje(this.ID);
        }
      // } else {
      //   this.outage_quantity = undefined;
      // }
      // else if (this.isEmptyTank) alert("Izabrani tank je prazan");
      else if (
        typeof this.wine_to_select === "undefined" &&
        this.tip_vina_izabrani_tank_pom !== this.tip_vina_tank &&
        this.tip_vina_izabrani_tank_pom !== null &&
        typeof this.tip_vina_izabrani_tank_pom !== "undefined"
      )
        alert("U tankovima se ne nalazi isto vino, morate navesti novo vino");
      else if (
        Number(this.faza) !== 0 &&
        Number(this.faza_izabrani_tank) !== Number(this.faza) &&
        typeof pom_phase_to_select === "undefined" &&
        this.faza_izabrani_tank !== null
      )
        alert(
          "Kupažiranje nije moguće, izabrani tankovi se ne nalaze u istoj fazi"
        );
      // else if (
      //   Number(this.tipVina) !== 0 &&
      //   Number(this.tipVina) !== Number(this.tip_vina_izabrani_tank) &&
      //   this.tip_vina_izabrani_tank !== 0
      // )
      //   alert(
      //     "Kupažiranje nije moguće, u izabranom tanku se nalazi " +
      //       this.tip_vina_izabrani_tank_naziv +
      //       " vino."
      //   );
      // else if (wine_quantity + outage_quantity > preostalo_izabrani_tank) {
      //   alert(
      //     "Količina vina u tanku је " +
      //       preostalo_izabrani_tank +
      //       " " +
      //       this.preostalo_izabrani_tank_jm +
      //       ", što je manje od unete količine!"
      //   );
      // }
      else if (
        Number(this.sediment_quantity) === 0 ||
        typeof this.sediment_quantity === "undefined" ||
        this.sediment_quantity === ""
      ) {
        var complexObject;
        var pom_jm_dolivanja_select;

        if (this.jm_dolivanja_select === null) pom_jm_dolivanja_select = "0";
        else if (typeof this.jm_dolivanja_select === "undefined")
          pom_jm_dolivanja_select = "0";
        else if (this.jm_dolivanja_select.id == null)
          pom_jm_dolivanja_select = this.jm_dolivanja_select;
        else pom_jm_dolivanja_select = this.jm_dolivanja_select.id;

        var pom_jm_outage_select;

        if (this.jm_outage_select === null) pom_jm_outage_select = "0";
        else if (typeof this.jm_outage_select === "undefined")
          pom_jm_outage_select = "0";
        else if (this.jm_outage_select.id == null)
          pom_jm_outage_select = this.jm_outage_select;
        else pom_jm_outage_select = this.jm_outage_select.id;

        var pom_tank_to_select;

        if (this.tank_to_select.tankPhaseWineId == null)
          pom_tank_to_select = this.tank_to_select;
        else pom_tank_to_select = this.tank_to_select.tankPhaseWineId;

        var pom_wine_to_select;
        if (typeof this.wine_to_select !== "undefined")
          if (typeof this.wine_to_select.id !== "undefined")
            if (this.wine_to_select.id == null)
              pom_wine_to_select = this.wine_to_select;
            else pom_wine_to_select = this.wine_to_select.id;
          else pom_wine_to_select = this.wine_to_select;

        if (
          Number(this.outage_quantity) === 0 ||
          this.outage_quantity === "" ||
          typeof this.outage_quantity === "undefined"
        ) {
          if (
            typeof this.wine_to_select !== "undefined" &&
            this.tip_vina_izabrani_tank_pom !== null &&
            typeof this.tip_vina_izabrani_tank_pom !== "undefined" &&
            this.tip_vina_izabrani_tank_pom !== this.tip_vina_tank
          )
            if (
              this.faza_izabrani_tank !== null &&
              typeof this.faza_izabrani_tank !== "undefined" &&
              typeof pom_phase_to_select !== "undefined" &&
              Number(pom_phase_to_select) !== 0
            )
              complexObject = {
                tankPhaseWineId: pom_tank_to_select,
                toTankId: this.id_tank,
                toPhaseId: pom_phase_to_select,
                toWineId: pom_wine_to_select,
                decantingDate: this.date + "T" + this.time,
                quantity: Number(this.wine_quantity),
                // sediment: 0,
                // outage: 0,
                quantityUnitOfMeasureId: pom_jm_dolivanja_select,
                // sedimentUnitOfMeasureId: null,
                // outageUnitOfMeasureId: null,
                description: this.opis,
              };
            else
              complexObject = {
                tankPhaseWineId: pom_tank_to_select,
                toTankId: this.id_tank,
                // toPhaseId: pom_phase_to_select,
                toWineId: pom_wine_to_select,
                decantingDate: this.date + "T" + this.time,
                quantity: Number(this.wine_quantity),
                // sediment: 0,
                // outage: 0,
                quantityUnitOfMeasureId: pom_jm_dolivanja_select,
                // sedimentUnitOfMeasureId: null,
                // outageUnitOfMeasureId: null,
                description: this.opis,
              };
          else if (
            this.faza_izabrani_tank !== null &&
            typeof this.faza_izabrani_tank !== "undefined" &&
            typeof pom_phase_to_select !== "undefined" &&
            Number(pom_phase_to_select) !== 0
          )
            complexObject = {
              tankPhaseWineId: pom_tank_to_select,
              toTankId: this.id_tank,
              toPhaseId: pom_phase_to_select,
              toWineId: pom_wine_to_select,
              decantingDate: this.date + "T" + this.time,
              quantity: Number(this.wine_quantity),
              // sediment: 0,
              // outage: 0,
              quantityUnitOfMeasureId: pom_jm_dolivanja_select,
              // sedimentUnitOfMeasureId: null,
              // outageUnitOfMeasureId: null,
              description: this.opis,
            };
          else
            complexObject = {
              tankPhaseWineId: pom_tank_to_select,
              toTankId: this.id_tank,
              // toPhaseId: pom_phase_to_select,
              toWineId: pom_wine_to_select,
              decantingDate: this.date + "T" + this.time,
              quantity: Number(this.wine_quantity),
              // sediment: 0,
              // outage: 0,
              quantityUnitOfMeasureId: pom_jm_dolivanja_select,
              // sedimentUnitOfMeasureId: null,
              // outageUnitOfMeasureId: null,
              description: this.opis,
            };
        } else if (
          typeof this.wine_to_select !== "undefined" &&
          this.tip_vina_izabrani_tank_pom !== null &&
          typeof this.tip_vina_izabrani_tank_pom !== "undefined" &&
          this.tip_vina_izabrani_tank_pom !== this.tip_vina_tank
        )
          if (
            this.faza_izabrani_tank !== null &&
            typeof this.faza_izabrani_tank !== "undefined" &&
            typeof pom_phase_to_select !== "undefined" &&
            Number(pom_phase_to_select) !== 0
          )
            complexObject = {
              tankPhaseWineId: pom_tank_to_select,
              toTankId: this.id_tank,
              toPhaseId: pom_phase_to_select,
              toWineId: pom_wine_to_select,
              decantingDate: this.date + "T" + this.time,
              quantity: Number(this.wine_quantity),
              // sediment: 0,
              outage: this.outage_quantity,
              quantityUnitOfMeasureId: pom_jm_dolivanja_select,
              // sedimentUnitOfMeasureId: null,
              outageUnitOfMeasureId: pom_jm_outage_select,
              description: this.opis,
            };
          else
            complexObject = {
              tankPhaseWineId: pom_tank_to_select,
              toTankId: this.id_tank,
              // toPhaseId: pom_phase_to_select,
              toWineId: pom_wine_to_select,
              decantingDate: this.date + "T" + this.time,
              quantity: Number(this.wine_quantity),
              // sediment: 0,
              outage: this.outage_quantity,
              quantityUnitOfMeasureId: pom_jm_dolivanja_select,
              // sedimentUnitOfMeasureId: null,
              outageUnitOfMeasureId: pom_jm_outage_select,
              description: this.opis,
            };
        else if (
          this.faza_izabrani_tank !== null &&
          typeof this.faza_izabrani_tank !== "undefined" &&
          typeof pom_phase_to_select !== "undefined" &&
          Number(pom_phase_to_select) !== 0
        )
          complexObject = {
            tankPhaseWineId: pom_tank_to_select,
            toTankId: this.id_tank,
            toPhaseId: pom_phase_to_select,
            toWineId: pom_wine_to_select,
            decantingDate: this.date + "T" + this.time,
            quantity: Number(this.wine_quantity),
            // sediment: 0,
            outage: this.outage_quantity,
            quantityUnitOfMeasureId: pom_jm_dolivanja_select,
            // sedimentUnitOfMeasureId: null,
            outageUnitOfMeasureId: pom_jm_outage_select,
            description: this.opis,
          };
        else
          complexObject = {
            tankPhaseWineId: pom_tank_to_select,
            toTankId: this.id_tank,
            // toPhaseId: pom_phase_to_select,
            toWineId: pom_wine_to_select,
            decantingDate: this.date + "T" + this.time,
            quantity: Number(this.wine_quantity),
            // sediment: 0,
            outage: this.outage_quantity,
            quantityUnitOfMeasureId: pom_jm_dolivanja_select,
            // sedimentUnitOfMeasureId: null,
            outageUnitOfMeasureId: pom_jm_outage_select,
            description: this.opis,
          };

        if (
          typeof pom_phase_to_select !== "undefined" &&
          this.prethodna_faza_stavke !== pom_phase_to_select
        ) {
          let pomDateTime = this.date + "T" + this.time;
          let izabranoVreme = Date.parse(pomDateTime);

          if (izabranoVreme > this.datetime_action) {
            if (
              confirm(
                "Da li ste sigurni da želite promenu faze na dan " +
                  this.date +
                  "?"
              )
            ) {
              this.$http
                .put(
                  this.globalServiceLocation +
                    this.globalPort +
                    "/tank_phase_wine/decanting/update/" +
                    this.ID,
                  complexObject,
                  {
                    headers: {
                      "Content-Type": "application/json",
                      Authorization:
                        "Bearer  " + localStorage.getItem("user-token"),
                    },
                  }
                )
                .then((response) => {
                  //  this.kolicinaVina =
                  //     Number(this.kolicinaVinaPom) + Number(this.wine_quantity);

                  if (response.data.isEmptyTank) {
                    this.kolicinaVina = 0;
                    this.isEmptyTank = true;
                  } else {
                    this.kolicinaVina =
                      Number(this.kolicinaVinaPom) + Number(this.wine_quantity);
                  }
                  // this.id_tank_phase_wine = response.data.toTankPhaseWineId;

                  serverBus.$emit("refresh_coupage", this.id_tank_phase_wine);

                  if (Number(pom_phase_to_select) !== 0)
                    this.faza = Number(pom_phase_to_select);
                  else this.faza = Number(this.faza_izabrani_tank);

                  if (typeof this.phase_to_select.phaseMark !== "undefined")
                    this.faza_mark = this.phase_to_select.phaseMark;

                  if (typeof this.jm_dolivanja_select.mark !== "undefined")
                    this.jm_mark = this.jm_dolivanja_select.mark;

                  this.clear();
                })
                .catch((e) => {
                  if (!e.response) {
                    alert(
                      this.$t("error.message")
                    );
                  } else {
                    if (e.response.status === 401) {
                      this.$refs.frmtoken
                        .osvezavanjeTokena(
                          localStorage.getItem("user-refresh-token")
                        )
                        .then((result) => {
                          this.$http
                            .put(
                              this.globalServiceLocation +
                                this.globalPort +
                                "/tank_phase_wine/decanting/update/" +
                                this.ID,
                              complexObject,
                              {
                                headers: {
                                  "Content-Type": "application/json",
                                  Authorization:
                                    "Bearer  " +
                                    localStorage.getItem("user-token"),
                                },
                              }
                            )
                            .then((response) => {
                              // this.kolicinaVina =
                              //   Number(this.kolicinaVinaPom) + Number(this.wine_quantity);

                              if (response.data.isEmptyTank) {
                                this.kolicinaVina = 0;
                                this.isEmptyTank = true;
                              } else {
                                this.kolicinaVina =
                                  Number(this.kolicinaVinaPom) +
                                  Number(this.wine_quantity);
                              }
                              // this.id_tank_phase_wine = response.data.toTankPhaseWineId;

                              serverBus.$emit(
                                "refresh_coupage",
                                this.id_tank_phase_wine
                              );

                              if (Number(pom_phase_to_select) !== 0)
                                this.faza = Number(pom_phase_to_select);
                              else this.faza = Number(this.faza_izabrani_tank);

                              if (
                                typeof this.phase_to_select.phaseMark !==
                                "undefined"
                              )
                                this.faza_mark = this.phase_to_select.phaseMark;

                              if (
                                typeof this.jm_dolivanja_select.mark !==
                                "undefined"
                              )
                                this.jm_mark = this.jm_dolivanja_select.mark;

                              this.clear();
                            })
                            .catch((e) => {
                              let pomError = readJSON(e.response.data.message);
                              alert(pomError);
                            });
                        });
                    } else {
                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    }
                  }
                });
            } else {
              if (
                confirm(
                  "Da li ste sigurni da želite promenu faze na dan " +
                    this.date +
                    "?"
                )
              ) {
                this.$http
                  .put(
                    this.globalServiceLocation +
                      this.globalPort +
                      "/tank_phase_wine/decanting/update/" +
                      this.ID,
                    complexObject,
                    {
                      headers: {
                        "Content-Type": "application/json",
                        Authorization:
                          "Bearer  " + localStorage.getItem("user-token"),
                      },
                    }
                  )
                  .then((response) => {
                    // this.kolicinaVina =
                    //   Number(this.kolicinaVinaPom) + Number(this.wine_quantity);

                    if (response.data.isEmptyTank) {
                      this.kolicinaVina = 0;
                      this.isEmptyTank = true;
                    } else {
                      this.kolicinaVina =
                        Number(this.kolicinaVinaPom) +
                        Number(this.wine_quantity);
                    }

                    // this.id_tank_phase_wine = response.data.toTankPhaseWineId;

                    serverBus.$emit("refresh_coupage", this.id_tank_phase_wine);

                    if (Number(pom_phase_to_select) !== 0)
                      this.faza = Number(pom_phase_to_select);
                    else this.faza = Number(this.faza_izabrani_tank);

                    if (typeof this.phase_to_select.phaseMark !== "undefined")
                      this.faza_mark = this.phase_to_select.phaseMark;

                    if (typeof this.jm_dolivanja_select.mark !== "undefined")
                      this.jm_mark = this.jm_dolivanja_select.mark;

                    this.clear();
                  })
                  .catch((e) => {
                    if (!e.response) {
                      alert(
                        this.$t("error.message")
                      );
                    } else {
                      if (e.response.status === 401) {
                        this.$refs.frmtoken
                          .osvezavanjeTokena(
                            localStorage.getItem("user-refresh-token")
                          )
                          .then((result) => {
                            this.$http
                              .put(
                                this.globalServiceLocation +
                                  this.globalPort +
                                  "/tank_phase_wine/decanting/update/" +
                                  this.ID,
                                complexObject,
                                {
                                  headers: {
                                    "Content-Type": "application/json",
                                    Authorization:
                                      "Bearer  " +
                                      localStorage.getItem("user-token"),
                                  },
                                }
                              )
                              .then((response) => {
                                // this.kolicinaVina =
                                //   Number(this.kolicinaVinaPom) + Number(this.wine_quantity);

                                if (response.data.isEmptyTank) {
                                  this.kolicinaVina = 0;
                                  this.isEmptyTank = true;
                                } else {
                                  this.kolicinaVina =
                                    Number(this.kolicinaVinaPom) +
                                    Number(this.wine_quantity);
                                }
                                // this.id_tank_phase_wine = response.data.toTankPhaseWineId;

                                serverBus.$emit(
                                  "refresh_coupage",
                                  this.id_tank_phase_wine
                                );

                                if (Number(pom_phase_to_select) !== 0)
                                  this.faza = Number(pom_phase_to_select);
                                else
                                  this.faza = Number(this.faza_izabrani_tank);

                                if (
                                  typeof this.phase_to_select.phaseMark !==
                                  "undefined"
                                )
                                  this.faza_mark =
                                    this.phase_to_select.phaseMark;

                                if (
                                  typeof this.jm_dolivanja_select.mark !==
                                  "undefined"
                                )
                                  this.jm_mark = this.jm_dolivanja_select.mark;

                                this.clear();
                              })
                              .catch((e) => {
                                let pomError = readJSON(
                                  e.response.data.message
                                );
                                alert(pomError);
                              });
                          });
                      } else {
                        let pomError = readJSON(e.response.data.message);
                        alert(pomError);
                      }
                    }
                  });
              }
            }
          } else {
            this.$http
              .put(
                this.globalServiceLocation +
                  this.globalPort +
                  "/tank_phase_wine/decanting/update/" +
                  this.ID,
                complexObject,
                {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization:
                      "Bearer  " + localStorage.getItem("user-token"),
                  },
                }
              )
              .then((response) => {
                // this.kolicinaVina =
                //   Number(this.kolicinaVinaPom) + Number(this.wine_quantity);

                if (response.data.isEmptyTank) {
                  this.kolicinaVina = 0;
                  this.isEmptyTank = true;
                } else {
                  this.kolicinaVina =
                    Number(this.kolicinaVinaPom) + Number(this.wine_quantity);
                }

                // this.id_tank_phase_wine = response.data.toTankPhaseWineId;

                serverBus.$emit("refresh_coupage", this.id_tank_phase_wine);

                if (Number(pom_phase_to_select) !== 0)
                  this.faza = Number(pom_phase_to_select);
                else this.faza = Number(this.faza_izabrani_tank);

                if (typeof this.phase_to_select.phaseMark !== "undefined")
                  this.faza_mark = this.phase_to_select.phaseMark;

                if (typeof this.jm_dolivanja_select.mark !== "undefined")
                  this.jm_mark = this.jm_dolivanja_select.mark;

                this.clear();
              })
              .catch((e) => {
                if (!e.response) {
                  alert(
                    this.$t("error.message")
                  );
                } else {
                  if (e.response.status === 401) {
                    this.$refs.frmtoken
                      .osvezavanjeTokena(
                        localStorage.getItem("user-refresh-token")
                      )
                      .then((result) => {
                        this.$http
                          .put(
                            this.globalServiceLocation +
                              this.globalPort +
                              "/tank_phase_wine/decanting/update/" +
                              this.ID,
                            complexObject,
                            {
                              headers: {
                                "Content-Type": "application/json",
                                Authorization:
                                  "Bearer  " +
                                  localStorage.getItem("user-token"),
                              },
                            }
                          )
                          .then((response) => {
                            // this.kolicinaVina =
                            //   Number(this.kolicinaVinaPom) + Number(this.wine_quantity);

                            if (response.data.isEmptyTank) {
                              this.kolicinaVina = 0;
                              this.isEmptyTank = true;
                            } else {
                              this.kolicinaVina =
                                Number(this.kolicinaVinaPom) +
                                Number(this.wine_quantity);
                            }

                            // this.id_tank_phase_wine = response.data.toTankPhaseWineId;

                            serverBus.$emit(
                              "refresh_coupage",
                              this.id_tank_phase_wine
                            );

                            if (Number(pom_phase_to_select) !== 0)
                              this.faza = Number(pom_phase_to_select);
                            else this.faza = Number(this.faza_izabrani_tank);

                            if (
                              typeof this.phase_to_select.phaseMark !==
                              "undefined"
                            )
                              this.faza_mark = this.phase_to_select.phaseMark;

                            if (
                              typeof this.jm_dolivanja_select.mark !==
                              "undefined"
                            )
                              this.jm_mark = this.jm_dolivanja_select.mark;

                            this.clear();
                          })
                          .catch((e) => {
                            let pomError = readJSON(e.response.data.message);
                            alert(pomError);
                          });
                      });
                  } else {
                    let pomError = readJSON(e.response.data.message);
                    alert(pomError);
                  }
                }
              });
          }
        }
      } else {
        this.Pretakanje(this.ID);
      }
    },
    getAllTankovi(svi) {
      let tipVinaPom = 0;

      if (svi === false) tipVinaPom = this.tipVina;

      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/tank/blending/" +
            this.id_tank +
            "/" +
            tipVinaPom,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.tank_to_items_init = response.data;
          this.tank_to_items_init.splice(0, 0, {
            id: undefined,
            name: undefined,
          });

          this.tank_to_items = this.tank_to_items_init;
        })
        .catch((e) => {
          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/tank/blending/" +
                        this.id_tank +
                        "/" +
                        tipVinaPom,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.tank_to_items_init = response.data;
                      this.tank_to_items_init.splice(0, 0, {
                        id: undefined,
                        name: undefined,
                      });

                      this.tank_to_items = this.tank_to_items_init;
                    })
                    .catch((e) => {
                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAllFaze() {
      this.$http
        .get(this.globalServiceLocation + this.globalPort + "/phase/all", {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer  " + localStorage.getItem("user-token"),
          },
        })
        .then((response) => {
          this.phase_to_items = response.data;

          this.phase_to_select = Number(this.faza);
        })
        .catch((e) => {
          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/phase/all",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.phase_to_items = response.data;

                      this.phase_to_select = Number(this.faza);
                    })
                    .catch((e) => {
                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAllVina() {
      this.$http
        .get(this.globalServiceLocation + this.globalPort + "/wine/all", {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer  " + localStorage.getItem("user-token"),
          },
        })
        .then((response) => {
          this.wine_to_items = response.data;

          if (Number(this.tip_vina_tank) !== 0)
            this.wine_to_select = Number(this.tip_vina_tank);
          else this.wine_to_select = undefined;
        })
        .catch((e) => {
          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/wine/all",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.wine_to_items = response.data;

                      if (Number(this.tip_vina_tank) !== 0)
                        this.wine_to_select = Number(this.tip_vina_tank);
                      else this.wine_to_select = undefined;
                    })
                    .catch((e) => {
                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    wineType(idTank) {
      if (!isNaN(idTank))
        this.$http
          .get(
            this.globalServiceLocation +
              this.globalPort +
              "/tank_phase_wine/tank/" +
              idTank +
              "/wine_type",
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer  " + localStorage.getItem("user-token"),
              },
            }
          )
          .then((response) => {
            if (response.data.id !== null) {
              this.tip_vina_izabrani_tank = response.data.id;
              this.tip_vina_izabrani_tank_naziv = response.data.name;
            } else {
              this.tip_vina_izabrani_tank = 0;
              this.tip_vina_izabrani_tank_naziv = "";
            }
          })
          .catch((e) => {
            if (!e.response) {
              alert(
                this.$t("error.message")
              );
            } else {
              if (e.response.status === 401) {
                this.$refs.frmtoken
                  .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                  .then((result) => {
                    this.$http
                      .get(
                        this.globalServiceLocation +
                          this.globalPort +
                          "/tank_phase_wine/tank/" +
                          idTank +
                          "/wine_type",
                        {
                          headers: {
                            "Content-Type": "application/json",
                            Authorization:
                              "Bearer  " + localStorage.getItem("user-token"),
                          },
                        }
                      )
                      .then((response) => {
                        if (response.data.id !== null) {
                          this.tip_vina_izabrani_tank = response.data.id;
                          this.tip_vina_izabrani_tank_naziv =
                            response.data.name;
                        } else {
                          this.tip_vina_izabrani_tank = 0;
                          this.tip_vina_izabrani_tank_naziv = "";
                        }
                      })
                      .catch((e) => {
                        let pomError = readJSON(e.response.data.message);
                        alert(pomError);
                      });
                  });
              } else {
                let pomError = readJSON(e.response.data.message);
                alert(pomError);
              }
            }
          });
      else this.phase_to_items_pom = [];
    },

    submit() {
      if (this.$refs.form.validate() && this.$refs.form1.validate()) {
        if (this.$refs.element1.validate()) {
          this.isLoading = true;

          setTimeout(() => {
            if (this.ID !== "" && Number(this.ID) !== 0) {
              this.changeSifarnik();
            } else {
              this.newSifarnik();
            }
          }, 1000);
        } else alert("Niste odabrali tank iz kog se uzima vino.");
      }
    },
    clear() {
      this.setTime();
      this.setDate();

      this.$refs.elementFaza.reset();
      this.$refs.form1.reset();
      this.$refs.element1.reset();
      this.$refs.element2.reset();
      this.$refs.element3.reset();

      this.ID = 0;

      // this.tank_to_select = "undefined"
      this.getAllFaze();
      this.getAllVina();

      this.disabled_tank = false;
      this.tankId = undefined;

      // this.faza = this.prethodna_faza;
      this.tekst_labele_1 = "Taloga";

      this.isLoading = false;
    },
    getAllJediniceMere() {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/unit_of_measure/group/1",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          let niz = [];
          let litar;

          response.data.forEach(function (entry) {
            if (entry.mark !== "ml") niz.push(entry);

            if (entry.mark === "l") litar = entry;
          });

          this.jm_items = niz;
          this.jm_outage_items = niz;
          this.jm_sediment_items = niz;

          this.jm_dolivanja_select = litar;
          this.jm_outage_select = litar;
          this.jm_sediment_select = litar;
        })
        .catch((e) => {
          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/unit_of_measure/group/1",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      let niz = [];
                      let litar;

                      response.data.forEach(function (entry) {
                        if (entry.mark !== "ml") niz.push(entry);

                        if (entry.mark === "l") litar = entry;
                      });

                      this.jm_items = niz;
                      this.jm_outage_items = niz;
                      this.jm_sediment_items = niz;

                      this.jm_dolivanja_select = litar;
                      this.jm_outage_select = litar;
                      this.jm_sediment_select = litar;
                    })
                    .catch((e) => {
                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    onCheckboxChange(newValue, oldValue) {
      if (newValue) {
        this.wine_quantity = this.preostalo_izabrani_tank;

        if (Number(this.id_jedinica_mere) !== 0)
          this.jm_dolivanja_select = Number(this.id_jedinica_mere);
      } else this.wine_quantity = undefined;
    },
    onCheckboxChangeTankovi(newValue, oldValue) {
      if (newValue) this.getAllTankovi(true);
      else this.getAllTankovi(false);
    },
  },
  mounted() {
    this.getAllJediniceMere();
    // this.getAllFaze();
    // this.getAllVina();
    this.clear();

    // this.setTime();
    // this.setDate();

    serverBus.$on("clear_coupage", (item) => {
      this.clear();
    });

    serverBus.$on("applied_coupage", (item) => {
      this.kolicinaVinaPom = Number(this.kolicinaVina) - Number(item.quantity);

      // this.id_tank_phase_wine_blend = item.tankPhaseWineBlendId;
      // alert(item.id)
      this.ID = item.id;

      this.wine_quantity = Number(item.quantity);

      // this.PreostaloUTanku(item.tankId);

      this.tank_to_items = [];

      let addNew = false;

      for (var i = 0; i < this.tank_to_items_init.length; i++) {
        if (this.tank_to_items_init[i].tankPhaseWineId === item.tankPhaseWineId)
          addNew = true;

        this.tank_to_items.push(this.tank_to_items_init[i]);
      }

      // this.tank_to_items = this.tank_to_items_init;

      if (!addNew) {
        let phaseName = "";

        if (item.phaseName === "Alkoholna fermentacija") phaseName = "AF";
        else if (item.phaseName === "Malolaktička fermentacija")
          phaseName = "MF";
        else if (item.phaseName === "Alkoholna malolaktička fermentacija")
          phaseName = "AM";
        else if (item.phaseName === "Odležavanje") phaseName = "OD";
        else phaseName = "ZA";

        this.tank_to_items.splice(1, 0, {
          id: item.tankId,
          name: item.tankName,
          phaseMark: phaseName,
          tankPhaseWineId: item.tankPhaseWineId,
        });
      }

      this.tank_to_select = this.tank_to_items.find(
        (x) => x.tankPhaseWineId === item.tankPhaseWineId
      );

      // this.tank_to_select = item.tankId;

      this.jm_dolivanja_select = item.unitOfMeasure.id;

      this.date = item.date.split("T")[0];
      this.time = this.formatTime(item.date.split("T")[1]);

      this.entry_date = item.entryDate;

      if (item.outage !== null && item.outage !== 0) {
        this.outage_quantity = item.outage.quantity;
        this.jm_outage_select = item.outage.unitOfMeasure.id;
      }

      if (item.sediment !== null && item.sediment !== 0) {
        this.sediment_quantity = item.sediment;
        if (item.sedimentUnitOfMeasure !== null)
          this.jm_sediment_select = item.sedimentUnitOfMeasure.id;
        else this.jm_sediment_select = null;
      }

      if (item.description === null) this.opis = "";
      else this.opis = item.description;

      if (item.tankPhaseWineId === 0) this.disabled_vine = false;
      else this.disabled_vine = true;

      // this.wine_select = undefined;
      this.disabled_tank = true;

      this.tip_vina_tank = Number(item.wineId);

      this.datetime_action = Date.parse(item.thisTankActivePhaseDate);
      this.phase_to_select = item.thisTankPhaseId;

      this.prethodna_faza_stavke = item.thisTankPhaseId;
    });

    serverBus.$on(
      "coupage",
      (
        id_tank_phase_wine,
        id_tank,
        kolicina_vina,
        faza,
        tip_vina,
        vino_id,
        id_akcije,
        faza_mark,
        jm_mark,
        tank_type,
        edit
      ) => {
        this.id_tank_phase_wine = Number(id_tank_phase_wine);
        this.id_tank = id_tank;

        this.PreostaloUTanku_novo(id_tank);

        // alert(kolicina_vina);

        if (Number(id_tank_phase_wine) === 0) this.disabled_vine = false;
        else this.disabled_vine = true;

        this.kolicinaVina = kolicina_vina;
        this.kolicinaVinaPom = this.kolicinaVina;

        this.faza_mark = faza_mark;
        this.jm_mark = jm_mark;
        // alert(faza);
        // alert(tip_vina);

        if (typeof edit !== "undefined") this.edit = edit;
        else this.edit = true;

        this.faza = faza;
        this.prethodna_faza = faza;

        if (Number(faza) !== 0) {
          this.phase_to_select = Number(faza);

          this.faza_vina = faza;
        }

        this.tipVina = tip_vina;

        this.tip_vina_tank = Number(vino_id);

        this.getAllTankovi(false);

        // if (tank_type === "press")
        //   this.tekst_labele_1 = "Komina";
        // else
        // if (Number(this.faza) === 1 && Number(this.tipVina) !== 2)
        //   this.tekst_labele_1 = "Komine";
        // else
        this.tekst_labele_1 = "Taloga";
      }
    );

    serverBus.$on("applied_coupage_delete", (kolicina, rastur, talog) => {
      this.kolicinaVina =
        Number(this.kolicinaVina) -
        Number(kolicina) -
        Number(rastur) -
        Number(talog);
      this.kolicinaVinaPom = Number(this.kolicinaVina);

      this.getAllTankovi(false);
      this.clear();
    });
  },
};
</script>

<style lang="scss" scoped>
@import "./../assets/sass/parts/modalStyles";

.coupageItemComponentForm {
  max-width: 430px;
}

.Description textarea {
  height: 40px;
}

// .v-input.v-text-field {
// 	margin: 0px;
// }

div.v-input.Description.v-textarea.v-text-field {
  margin-top: 0px;
}

div.flex.pa-2 {
  padding-bottom: 0px !important;
  padding-top: 0px !important;
}

#FloatingButton {
  position: absolute;
  width: 36px;
  height: 36px;
  font-size: 25px;
  border-radius: 50%;
  color: #ffffff;
  background-color: #018389;
  // transition: .2s ease-in-out;
  // p {
  //   position: relative;
  //   width: 100%;
  //   height: 100%;
  //   i {
  //     position: absolute;
  //     left: 6px;
  //     top: 6px;
  //     transform: rotate(45deg);
  //     color: #ffffff;
  //   }
  // }
  &:active,
  &:focus {
    box-shadow: none;
  }
}
</style>
